var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.32,238.75c205.08-.61,435.12-.62,640.19,0-205.08.62-435.12.61-640.19,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.72,178.08s8.87-31.84,15.95-42.65S157,112.74,157,112.74,156.65,161.82,120.72,178.08Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.35,177.53a153.72,153.72,0,0,0,8.09-15.42,108.21,108.21,0,0,1,4.4-16.74.08.08,0,0,1,.16,0c-1.18,5-2.55,10-3.79,15,3.58-7.75,7-15.59,11.25-22.92a48.66,48.66,0,0,1,4.11-10.18c.05-.09.2,0,.16.05a65.44,65.44,0,0,0-2.77,7.65,74.13,74.13,0,0,1,6.74-9.31c.15-.19.46,0,.31.21-5.7,7.28-9.64,15.56-13.39,23.94A125.83,125.83,0,0,0,147.75,136a0,0,0,0,1,.08.05,113.72,113.72,0,0,1-11.92,15.45c-2.73,6.14-5.41,12.31-8.66,18.15,6.5-5.5,11.5-12.61,16.45-19.47.11-.16.35,0,.25.17-5,7.53-10.08,14.62-17.21,20.19A79.47,79.47,0,0,1,122,178,.38.38,0,0,1,121.35,177.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,178.12s15.94-29.35,11.31-57.81-9.59-38.59-9.59-38.59S95.69,126,119,178.12Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.49,132a138.93,138.93,0,0,0,6.15,23.7c0-10.45.25-20.89.52-31.33a81,81,0,0,1-3-19.45c0-.2.28-.19.29,0a109.75,109.75,0,0,0,2.8,16.74q.36-12.93.84-25.84a.11.11,0,0,1,.22,0c0,13.46,0,26.92-.09,40.38a108,108,0,0,0,4.6-16,0,0,0,0,1,.09,0,62.47,62.47,0,0,1-4.71,18.2c-.06,8.6-.15,17.2-.34,25.8,2.69-9.14,5.57-18,6.36-27.66a.1.1,0,0,1,.2,0c-.21,10.66-3,21.48-6.48,31.5a.58.58,0,0,1-.17.25q-.12,4.72-.28,9.43a.35.35,0,0,1-.7,0q-.18-9.65-.16-19.3A86.43,86.43,0,0,1,112.35,132C112.34,131.91,112.48,131.9,112.49,132Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.58,127.44a53.38,53.38,0,0,1,1.11,7.75c0,.09-.13.1-.15,0a54.49,54.49,0,0,1-1.31-7.73C113.21,127.28,113.54,127.24,113.58,127.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.9,106c0-.09.15-.06.15,0a19.36,19.36,0,0,1-.8,5.35.11.11,0,0,1-.21-.06C122.39,109.52,122.6,107.75,122.9,106Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.21,178.12s.65-30.64-8.14-45.87-23.37-23-23.37-23S87.58,163.27,113.21,178.12Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.19,151.92A114.13,114.13,0,0,0,109.08,167q-2.62-9.41-6.08-18.48c-4.93-4.32-9.82-8.8-12.84-14.71a.09.09,0,0,1,.15-.09c3.25,5.24,7.59,9.43,12.17,13.46a237.87,237.87,0,0,0-12.24-26.65.19.19,0,0,1,.34-.19,145.79,145.79,0,0,1,7.67,14c-.83-3.27-1.48-6.62-2.33-9.87a.07.07,0,1,1,.14,0,55.48,55.48,0,0,1,3.61,13,155,155,0,0,1,7.74,21c-.23-4.59-.51-9.17-1-13.75,0-.08.14-.1.15,0A74.08,74.08,0,0,1,107.91,160c1.26,4.56,2.33,9.18,3.18,13.84,0,.12-.16.18-.19.05q-.72-2.93-1.52-5.82s-.07,0-.1,0c-4.72-4.72-9.2-10.1-12.14-16.12A0,0,0,1,1,97.19,151.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,127c1,1,1.88,2.17,2.83,3.26a25.26,25.26,0,0,1,2.53,2.95s0,.1-.07.07a15,15,0,0,1-2.92-2.88,24.33,24.33,0,0,1-2.51-3.3A.09.09,0,0,1,87,127Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.27,180.36l-1.11,14.52-3.34,43.87H104.7l-3.34-43.87-1.1-14.52h38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.27,180.36l-.67,8.83L101,190.65l-.78-10.29h38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.67,
    y: 173.24,
    width: 43.19,
    height: 11.13,
    transform: "translate(238.52 357.61) rotate(180)",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.86,264.39c-.22,2.82,7.84,3.63,11.2,1.8a78,78,0,0,0,7.75-6.37c8.07-7.14,19.24-17.59,19.24-17.59l48.67,17.17,17-44.08s-43.81-17.92-46.55-19l-.51-.2c-12.47-4.79-22.81-8.43-23.87-7.68C192,190.44,162.07,261.55,161.86,264.39Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.85,264.38c-.21,2.83,7.84,3.63,11.2,1.82a75.64,75.64,0,0,0,7.76-6.38c8.08-7.13,19.24-17.58,19.24-17.58l18.9,6.81,18.56-46.51c-.21-.09-40.36-15.76-42.69-14.09C192,190.47,162.07,261.56,161.85,264.38Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.85,264.38c-.21,2.83,7.84,3.63,11.2,1.82a75.64,75.64,0,0,0,7.76-6.38c8.08-7.13,19.24-17.58,19.24-17.58l18.9,6.81,18.56-46.51c-.21-.09-40.36-15.76-42.69-14.09C192,190.47,162.07,261.56,161.85,264.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.76,264.84c5.47-12.06,26.4-61.24,30.89-73.58,0-.1,0-.13-.08,0-5.68,11.84-26.21,61.18-31,73.52C164.46,265,164.65,265.09,164.76,264.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.28,259.23a12.32,12.32,0,0,0-.1-9.91,12,12,0,0,0-6.35-6.21c-.09,0-.15.13-.07.18a14.22,14.22,0,0,1,6.34,15.87A.1.1,0,0,0,181.28,259.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.85,264.38c-.21,2.83,7.84,3.63,11.21,1.82a77.75,77.75,0,0,0,7.74-6.38c8.09-7.13,19.25-17.58,19.25-17.58l18.9,6.82,11.75-29.45L189.24,199.2C179.76,219.65,162,262.21,161.85,264.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,254.11s87.83,20.16,120.14,14.34c15.46-2.79,26.62-22.68,19.19-37.92-6.93-14.22-49.33-28.66-61.31-37-3.77-2.62-3.37-13-3.37-13l-31.46-.42s-11.22,17.82-6.46,26.49a3.28,3.28,0,0,0,.26.43l-14.19-5.39Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.67,254.11s87.83,20.16,120.14,14.34c15.46-2.79,26.62-22.68,19.19-37.92-6.93-14.22-49.33-28.66-61.31-37-3.77-2.62-3.37-13-3.37-13l-31.46-.42s-11.22,17.82-6.46,26.49a3.28,3.28,0,0,0,.26.43l-14.19-5.39Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M235.11,230.35c3.5-7.6,7.35-15,10.91-22.61.07-.15.3-.07.24.08-3.37,7.64-6.47,15.38-10,23s-7.29,15.07-11,22.59c-.1.19-.41.09-.32-.11C228.4,245.62,231.63,237.94,235.11,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.46,207.36c2.16,1.26,4.23,2.73,6.34,4.09s4.17,2.66,6.3,3.93c4.29,2.55,8.68,4.94,13.13,7.21A224.91,224.91,0,0,0,306,234.53c5.29,1.86,10.64,3.68,16.09,5a.09.09,0,0,1-.05.18c-4-1-7.94-1.88-11.86-3,2.08,1.31,4.12,2.68,6.19,4a.09.09,0,1,1-.1.16c-2.26-1.36-4.55-2.68-6.8-4.07a.22.22,0,0,1-.06-.32c-.67-.2-1.34-.38-2-.59-4.85-1.5-9.65-3.19-14.36-5.09a176.51,176.51,0,0,1-26.85-13.58c-2.41-1.49-4.8-3-7.15-4.61a66.59,66.59,0,0,1-6.77-5C252.07,207.5,252.28,207.26,252.46,207.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.55,275.18c-.22,2.82,7.84,3.63,11.2,1.8a78,78,0,0,0,7.75-6.37c8.07-7.14,19.24-17.59,19.24-17.59l47.47,17.13,18.25-44s-19.55-8.27-38.14-15.68c-2.86-1.14-5.68-2.24-8.42-3.31l-.51-.2c-12.47-4.79-22.81-8.43-23.87-7.68C161.67,201.23,131.76,272.34,131.55,275.18Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.55,275.18c-.22,2.82,7.84,3.63,11.2,1.8a75.62,75.62,0,0,0,7.75-6.37c8.07-7.14,19.25-17.59,19.25-17.59l27,11L216,217.75,188.9,207.12l-.5-.2c-12.49-4.8-22.81-8.43-23.88-7.68C161.67,201.22,131.77,272.34,131.55,275.18Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.55,275.18c-.22,2.82,7.84,3.63,11.2,1.8a75.62,75.62,0,0,0,7.75-6.37c8.07-7.14,19.25-17.59,19.25-17.59l27,11L216,217.75,188.9,207.12l-.5-.2c-12.49-4.8-22.81-8.43-23.88-7.68C161.67,201.22,131.77,272.34,131.55,275.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,276.18c5.45-12.07,26.29-61.28,30.76-73.63,0-.1,0-.13-.07,0-5.67,11.85-26.11,61.23-30.89,73.59C133.66,276.36,133.85,276.44,134,276.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.63,269a12.32,12.32,0,0,0-.1-9.91,12,12,0,0,0-6.35-6.21c-.09,0-.15.13-.07.18a14.22,14.22,0,0,1,6.34,15.87A.1.1,0,0,0,151.63,269Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.91,180.29l-54.1-.82s-11.48,29.2-6.73,37.89,54.58,21.1,54.58,21.1l-68.5-26.07-22.8,52.5S268.65,283,312.83,278.54c16.58-1.69,27-23.35,17.27-40-10.21-17.5-47.29-41.45-47.29-41.45Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.91,180.29l-54.1-.82s-11.48,29.2-6.73,37.89,54.58,21.1,54.58,21.1l-68.5-26.07-22.8,52.5S268.65,283,312.83,278.54c16.58-1.69,27-23.35,17.27-40-10.21-17.5-47.29-41.45-47.29-41.45Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.94,212.26c21,9.58,42.12,18.74,63.76,26.73q4.5,1.66,9,3.29c3.12,1.12,6.23,2.41,9.42,3.31.16,0,.08.29-.07.24-2.76-1-5.62-1.77-8.42-2.69s-5.47-1.81-8.19-2.76L272,239.13c.24.17.47.34.71.49,1.08.72,2.15,1.45,3.22,2.19,2.19,1.54,4.22,3.37,6.52,4.74.14.08,0,.31-.14.21-2.18-1.55-4.64-2.71-6.88-4.17-1.09-.71-2.16-1.45-3.21-2.2a21.31,21.31,0,0,1-2.83-2.18q-5.16-1.85-10.3-3.79-16.17-6.16-31.93-13.28c-5.87-2.66-11.68-5.42-17.42-8.34C209.39,212.65,209.63,212.12,209.94,212.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.6,240.69c3.49-7.61,7.34-15.05,10.9-22.62.07-.15.3-.07.24.08-3.36,7.64-6.47,15.38-10,23s-7.3,15.06-11,22.58c-.1.19-.41.09-.32-.11C196.88,256,200.11,248.27,203.6,240.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.79,197.66A149.75,149.75,0,0,1,300.88,209c5.43,4,10.68,8.28,15.69,12.81q3.8,3.44,7.33,7.13a54.6,54.6,0,0,1,6.22,7.52,26.37,26.37,0,0,1,4.49,16.5,28.06,28.06,0,0,1-2.15,9,33.12,33.12,0,0,1-5,7.74c-.08.1-.22,0-.13-.14a21.14,21.14,0,0,0,4.23-7.4,27.92,27.92,0,0,0-2.12-23.81c-3.32-5.51-8.2-10.09-12.84-14.48a195.64,195.64,0,0,0-15-12.81c-2.93-2.25-5.92-4.45-8.93-6.6s-6.08-4.23-9-6.48A.2.2,0,0,1,283.79,197.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.07,199.84a63.45,63.45,0,0,1,13.82-2.64c4.61-.52,9.23-.76,13.86-.83a.1.1,0,0,1,0,.19c-4.7.42-9.39,1-14.05,1.71s-9,1.65-13.59,2C267.84,200.31,267.84,199.92,268.07,199.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.28,200.49a67,67,0,0,0,8.61-.79c2.37-.34,4.79-.69,6.76-2.16,3.84-2.88,5.4-7.94,6.21-12.46,0-.11.2-.08.19,0-.65,4.92-.88,10.56-5.19,13.86a13.05,13.05,0,0,1-7.35,2.3,46.89,46.89,0,0,1-9.24-.57A.11.11,0,0,1,231.28,200.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.32,208.28a57.42,57.42,0,0,1,1.52-8.44c.68-2.86,1.49-5.68,2.39-8.47,1-3.16,2.22-6.28,3.47-9.36,0-.12.22-.07.18.05-1.78,5.22-3.41,10.51-4.77,15.87-.68,2.65-1.28,5.31-1.81,8a16.58,16.58,0,0,0-.05,7.86,13.85,13.85,0,0,0,4.33,6.74s0,.05,0,0A14.18,14.18,0,0,1,225.32,208.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.07,224.32c3.65,1,7.22,2.21,10.81,3.38s7.19,2.33,10.77,3.52c7.17,2.39,14.31,4.86,21.46,7.33,4.05,1.4,8.08,2.9,12.11,4.37.12,0,.06.22-.05.18q-21.66-6.72-43-14.26c-4-1.42-8.15-2.74-12.11-4.39A.07.07,0,0,1,216.07,224.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.33,122.28c-.89,16.24,1.47,51.14,7.25,63.26,2.49,5.22,18.65,19.09,30.31,25.91,4.35,2.55,21.18-21.82,16.76-25.1-3-2.24-21.78-16.59-23.51-19-3.19-4.39-14.4-36.74-20.88-50.2C281.64,109.65,275.88,112.17,275.33,122.28Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.77,206.83a88,88,0,0,0,8.62,8.83c2.51,2,9.91,7.65,12.41,5.11,1.71-1.74-2.25-5.56-5-8.33-1.44-1.46-2.83-4.18-1.85-5.09,1.72-1.59,5.4,2.26,7.64,5.21,4.33,5.71,9.37,17.52,14.07,16.07,1.78-.54,1.16-5.82-.26-8.71,2.68,3.8,4.13,7.89,7.27,7.86,1.18,0,2.08-2.29,2-3.52a2.79,2.79,0,0,0,3,.73c1.7-.74,1.88-2.81,1.37-5.23a1.53,1.53,0,0,0,1.37-.25c4.1-2.78-3.86-19-7.77-21.82a118.93,118.93,0,0,0-25.17-13.41C319.81,186.19,308.77,206.82,308.77,206.83Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.44,202.92a23.38,23.38,0,0,1,7.14,6.83c2.35,3.49,3.45,6.88,5.11,10.53a.08.08,0,0,1-.15.07c-.79-1.73-4.27-8.47-5.23-10.07a22.33,22.33,0,0,0-6.9-7.31S332.41,202.9,332.44,202.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.08,198.5a56.38,56.38,0,0,1,8.47,7.56c2.68,3.16,4.16,7.11,5.65,10.92q1.33,3.45,2.52,6.94c0,.1-.11.17-.15.07q-2.24-5.9-4.81-11.63a29.64,29.64,0,0,0-6.65-9.47c-1.62-1.53-3.34-2.93-5.07-4.34C337,198.53,337,198.47,337.08,198.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.64,195.26c3,2,5.58,3.79,7.74,6.74A50.86,50.86,0,0,1,356,213.26c.79,2.12,1.51,4.27,2.2,6.43,0,.08-.13.14-.16.05a116.36,116.36,0,0,0-5.82-14,23.61,23.61,0,0,0-4.05-5.93,42.46,42.46,0,0,0-5.56-4.53S342.62,195.25,342.64,195.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.84,167.2l-27.07,15.24s-7.48-37.59-5.14-57.74c1.83-15.72,7.21-16.39,12.9-4.29S306.84,167.2,306.84,167.2Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,157.57a12.89,12.89,0,0,1,0,1.39c-.21-1.66-.41-3.36-.6-5.08A16.92,16.92,0,0,1,276,157.57Zm19-19.57c-.08,1.11-.15,2.21-.28,3.31-.41,3.62-1.72,7.48-5.23,9.19a5.06,5.06,0,0,1-4.85-.08,6.67,6.67,0,0,1-2.85-4.26c-1-4.4,1.71-8.54,3.78-12.18,2-3.4,3.7-7.14,3-11.13-.4-.89-.77-1.71-1.12-2.44-.62-1.32-1.24-2.49-1.85-3.51a10.9,10.9,0,0,0-7.73-3.55,6.74,6.74,0,0,0-.79,1.2,10,10,0,0,1,7.65,3.16,10.57,10.57,0,0,1,2.69,8.67c-.61,3.91-3.11,7.19-4.91,10.62-1.58,3-2.74,6.5-1.75,9.92.8,2.74,3,5.19,6,5.36,2.76.16,5.26-1.59,6.82-3.74,1.71-2.35,2.24-5.23,2.49-8.08Q295.59,139.21,295.08,138Zm9.23,22.82c-3.18.85-6.52.55-9.79.38s-6.74-.19-9.83,1.14a9,9,0,0,0-5.42,6.34,6.49,6.49,0,0,0,3.69,7.2A12.13,12.13,0,0,0,289.5,177l3.05-1.71c-2.88.67-6,.94-8.73-.29a5.53,5.53,0,0,1-3.47-4.25,6.58,6.58,0,0,1,1.41-4.66c2.37-3.19,6.73-3.79,10.44-3.74,4.17.06,8.41.8,12.5-.34l.06,0C304.62,161.59,304.47,161.21,304.31,160.82Zm-28.87-6.94c.19,1.72.39,3.42.6,5.08a12.89,12.89,0,0,0,0-1.39A16.92,16.92,0,0,0,275.44,153.88ZM295.08,138c-.08,1.11-.15,2.21-.28,3.31-.41,3.62-1.72,7.48-5.23,9.19a5.06,5.06,0,0,1-4.85-.08,6.67,6.67,0,0,1-2.85-4.26c-1-4.4,1.71-8.54,3.78-12.18,2-3.4,3.7-7.14,3-11.13-.4-.89-.77-1.71-1.12-2.44-.62-1.32-1.24-2.49-1.85-3.51a10.9,10.9,0,0,0-7.73-3.55,6.74,6.74,0,0,0-.79,1.2,10,10,0,0,1,7.65,3.16,10.57,10.57,0,0,1,2.69,8.67c-.61,3.91-3.11,7.19-4.91,10.62-1.58,3-2.74,6.5-1.75,9.92.8,2.74,3,5.19,6,5.36,2.76.16,5.26-1.59,6.82-3.74,1.71-2.35,2.24-5.23,2.49-8.08Q295.59,139.21,295.08,138Zm9.23,22.82c-3.18.85-6.52.55-9.79.38s-6.74-.19-9.83,1.14a9,9,0,0,0-5.42,6.34,6.49,6.49,0,0,0,3.69,7.2A12.13,12.13,0,0,0,289.5,177l3.05-1.71c-2.88.67-6,.94-8.73-.29a5.53,5.53,0,0,1-3.47-4.25,6.58,6.58,0,0,1,1.41-4.66c2.37-3.19,6.73-3.79,10.44-3.74,4.17.06,8.41.8,12.5-.34l.06,0C304.62,161.59,304.47,161.21,304.31,160.82Z",
    style: {
      fill: "#030402",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.49,169.65l-22.72,12.79s-7.49-37.59-5.14-57.74c.95-8.13,2.84-12.23,5.24-12.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.06 168.28 279.98 186.05 280.12 184.63 277.86 184.15 277.97 183.08 276.52 180.48 307.19 163.77 307.04 165.26 308.93 166.05 308.62 167.38 310.06 168.28",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.06 168.28 279.98 186.05 280.12 184.63 277.86 184.15 277.97 183.08 276.52 180.48 307.19 163.77 307.04 165.26 308.93 166.05 308.62 167.38 310.06 168.28",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.73,189.43l70.72-1c-.23,1.4-.08-35.4-8.74-71.32-1.92-7.95-13.72-11.39-19.43-7.63C240.25,125.94,222.58,190.35,222.73,189.43Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9,132.74a50.29,50.29,0,0,1-5.58,2.7c.32-.59.64-1.17,1-1.75,5.94-2.69,12.43-6.82,13.84-13.62a12.35,12.35,0,0,0-.09-5.41c.32-.33.65-.65,1-1,.06.2.12.41.17.62a13.75,13.75,0,0,1-1.6,10.29A23.25,23.25,0,0,1,249.9,132.74Zm34.8-15.64a9.11,9.11,0,0,0-.52-1.55h0a11.24,11.24,0,0,0-1.66-1,11.67,11.67,0,0,0-10.31,0c-3.62,1.8-5.78,5.46-7.11,9.14a19.61,19.61,0,0,0-.81,11.94c2.09,7.4,9,12.44,10.34,20.11.63,3.5.07,7.5-3.06,9.66s-7.86,1.64-11.32.31-7.18-5-5.7-9.13c.75-2.1,2.57-3.6,4.08-5.17a10.69,10.69,0,0,0,2.65-4.21,5,5,0,0,0-.54-4.42,6.92,6.92,0,0,0-4.72-2.4,11.39,11.39,0,0,0-9.37,3.06c-3.08,3-3.41,7.2-4.53,11.12a11.39,11.39,0,0,1-2.84,5.22,9.32,9.32,0,0,1-4.84,2.46,7.62,7.62,0,0,1-2.43,0l-.46,1.17a9.86,9.86,0,0,0,6.16-1.06,11.67,11.67,0,0,0,5.57-7.52c1-3.45,1.25-7.37,3.79-10.14a10.24,10.24,0,0,1,8.2-3.21c1.6.12,3.56.63,4.53,2a4.16,4.16,0,0,1,.08,4c-1.33,3.17-4.65,4.86-6.15,7.92a7.66,7.66,0,0,0,1.62,8.5c2.4,2.53,6,3.75,9.45,4.05,3,.28,6.28-.29,8.53-2.48a10.14,10.14,0,0,0,2.71-7.94,19.23,19.23,0,0,0-2.88-8.92c-1.71-2.84-3.78-5.43-5.46-8.29a17.83,17.83,0,0,1-2.8-9.68A21.9,21.9,0,0,1,268,120.26a11,11,0,0,1,8.23-5.65,10,10,0,0,1,8.56,3.1l.06.07C284.81,117.55,284.75,117.33,284.7,117.1Zm5.83,32.83a5.78,5.78,0,0,1-1,.57,5.06,5.06,0,0,1-4.85-.08,6.67,6.67,0,0,1-2.85-4.26c-1-4.4,1.71-8.54,3.78-12.18a35,35,0,0,0,1.87-3.66c-.14-.73-.28-1.47-.43-2.21-.95,3.17-3,6-4.51,8.89s-2.74,6.5-1.75,9.92c.8,2.74,3,5.19,6,5.36a6.88,6.88,0,0,0,3.91-1C290.64,150.81,290.59,150.37,290.53,149.93Zm-53.81,21.2a10,10,0,0,0-7.41-1.68c-.16.43-.32.86-.46,1.29,3.37-.63,7.22.26,9,3.46,1.41,2.58,1,5.66.5,8.44-.39,2.19-.92,4.38-1.14,6.59l1.2,0c.15-1.35.42-2.7.67-4C240,180.45,241.19,174.55,236.72,171.13Zm37.48,6.93c-5-4.19-11.52-8.85-18.44-7.66A9.72,9.72,0,0,0,249,175a7.4,7.4,0,0,0-.32,7.53c1.65,2.79,4.86,4.06,7.79,5.07,1.24.43,2.49.85,3.74,1.26l3.64,0c-.16,0-.32-.1-.48-.15-2.22-.75-4.46-1.49-6.68-2.26-3.25-1.12-7.44-2.86-7.7-6.85-.22-3.25,2.27-6.37,5.2-7.51,3.65-1.43,7.81-.33,11.18,1.33,3.87,1.9,7.21,4.76,10.43,7.58a90.4,90.4,0,0,0,9.4,7.56l2.17,0C282.51,185.68,278.47,181.64,274.2,178.06Zm18.62-2.88c-3,.72-6.16,1-9-.22a5.53,5.53,0,0,1-3.47-4.25,6.58,6.58,0,0,1,1.41-4.66c2.3-3.09,6.47-3.75,10.1-3.74,0-.39-.07-.79-.11-1.2a17.71,17.71,0,0,0-7.06,1.23,9,9,0,0,0-5.42,6.34,6.49,6.49,0,0,0,3.69,7.2,13.2,13.2,0,0,0,8.16.88c.59-.1,1.19-.22,1.77-.37C292.87,176,292.85,175.59,292.82,175.18ZM284.7,117.1a9.11,9.11,0,0,0-.52-1.55h0a11.24,11.24,0,0,0-1.66-1,11.67,11.67,0,0,0-10.31,0c-3.62,1.8-5.78,5.46-7.11,9.14a19.61,19.61,0,0,0-.81,11.94c2.09,7.4,9,12.44,10.34,20.11.63,3.5.07,7.5-3.06,9.66s-7.86,1.64-11.32.31-7.18-5-5.7-9.13c.75-2.1,2.57-3.6,4.08-5.17a10.69,10.69,0,0,0,2.65-4.21,5,5,0,0,0-.54-4.42,6.92,6.92,0,0,0-4.72-2.4,11.39,11.39,0,0,0-9.37,3.06c-3.08,3-3.41,7.2-4.53,11.12a11.39,11.39,0,0,1-2.84,5.22,9.32,9.32,0,0,1-4.84,2.46,7.62,7.62,0,0,1-2.43,0l-.46,1.17a9.86,9.86,0,0,0,6.16-1.06,11.67,11.67,0,0,0,5.57-7.52c1-3.45,1.25-7.37,3.79-10.14a10.24,10.24,0,0,1,8.2-3.21c1.6.12,3.56.63,4.53,2a4.16,4.16,0,0,1,.08,4c-1.33,3.17-4.65,4.86-6.15,7.92a7.66,7.66,0,0,0,1.62,8.5c2.4,2.53,6,3.75,9.45,4.05,3,.28,6.28-.29,8.53-2.48a10.14,10.14,0,0,0,2.71-7.94,19.23,19.23,0,0,0-2.88-8.92c-1.71-2.84-3.78-5.43-5.46-8.29a17.83,17.83,0,0,1-2.8-9.68A21.9,21.9,0,0,1,268,120.26a11,11,0,0,1,8.23-5.65,10,10,0,0,1,8.56,3.1l.06.07C284.81,117.55,284.75,117.33,284.7,117.1Zm5.83,32.83a5.78,5.78,0,0,1-1,.57,5.06,5.06,0,0,1-4.85-.08,6.67,6.67,0,0,1-2.85-4.26c-1-4.4,1.71-8.54,3.78-12.18a35,35,0,0,0,1.87-3.66c-.14-.73-.28-1.47-.43-2.21-.95,3.17-3,6-4.51,8.89s-2.74,6.5-1.75,9.92c.8,2.74,3,5.19,6,5.36a6.88,6.88,0,0,0,3.91-1C290.64,150.81,290.59,150.37,290.53,149.93Zm-53.81,21.2a10,10,0,0,0-7.41-1.68c-.16.43-.32.86-.46,1.29,3.37-.63,7.22.26,9,3.46,1.41,2.58,1,5.66.5,8.44-.39,2.19-.92,4.38-1.14,6.59l1.2,0c.15-1.35.42-2.7.67-4C240,180.45,241.19,174.55,236.72,171.13Zm37.48,6.93c-5-4.19-11.52-8.85-18.44-7.66A9.72,9.72,0,0,0,249,175a7.4,7.4,0,0,0-.32,7.53c1.65,2.79,4.86,4.06,7.79,5.07,1.24.43,2.49.85,3.74,1.26l3.64,0c-.16,0-.32-.1-.48-.15-2.22-.75-4.46-1.49-6.68-2.26-3.25-1.12-7.44-2.86-7.7-6.85-.22-3.25,2.27-6.37,5.2-7.51,3.65-1.43,7.81-.33,11.18,1.33,3.87,1.9,7.21,4.76,10.43,7.58a90.4,90.4,0,0,0,9.4,7.56l2.17,0C282.51,185.68,278.47,181.64,274.2,178.06Zm18.62-2.88c-3,.72-6.16,1-9-.22a5.53,5.53,0,0,1-3.47-4.25,6.58,6.58,0,0,1,1.41-4.66c2.3-3.09,6.47-3.75,10.1-3.74,0-.39-.07-.79-.11-1.2a17.71,17.71,0,0,0-7.06,1.23,9,9,0,0,0-5.42,6.34,6.49,6.49,0,0,0,3.69,7.2,13.2,13.2,0,0,0,8.16.88c.59-.1,1.19-.22,1.77-.37C292.87,176,292.85,175.59,292.82,175.18Z",
    style: {
      fill: "#030402",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.12,120.86c-7.87,10.84-15.8,58.55-15,63.24,3.11,17.31,39.15,36.53,52.27,41.28,3.68,1.34,9.1-29.78,5.21-31.31-7.64-3-29.61-13.76-30.82-16.68s-1.74-36.95-1.76-51.08C268,114.4,262.1,115.38,258.12,120.86Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.24,193s6.25,1.08,12.1,2.35c7,1.52,23.61,8.62,27.76,28.4,1.6,7.58-3,12-6.08,4.43-2.15-5.34-3.18-9.23-4.37-10.77,0,0-2.51,8.44-7.35,10.09a94.09,94.09,0,0,1-12.94,3.39,20.4,20.4,0,0,1-.85-2.36,10.71,10.71,0,0,1-10.84-3.63Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.93,197.56c2.39,2.92,7.35,9.18,9.63,15.72,2.53,7.26,5.45,21.92.07,23.73-3.94,1.33-5.55-4.17-5.55-4.17s-.07,6.32-3.89,6.74c-3.49.38-4.48-4-4.48-4s-.7,3.83-4.13,3.55c-4.12-.33-2-8.29-5.86-12.24C300.85,226.06,315.93,197.56,315.93,197.56Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.45,214.67a30.67,30.67,0,0,1,2.74,18.05c0,.16-.16.22-.17.07a75.52,75.52,0,0,0-2.64-18.09A0,0,0,0,1,317.45,214.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.19,217.44c1.28,2.84,3.25,11.31,1.67,18.18,0,.16-.18.21-.17.06a80.82,80.82,0,0,0-1.57-18.22S310.18,217.4,310.19,217.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.16,178.8c9.3,5.16,18.65,10.38,28.6,14.15,6.42.79,13,1.92,18.78,4.94,10.19,5.48,17.91,16,18.95,27.58a8.41,8.41,0,0,1-1.13,5.56,8.63,8.63,0,0,0,.73-5.52c-1.69-11.21-9.32-21-19.23-26.32-5.68-2.89-12.05-4-18.33-4.88-10-3.92-19.38-9.6-28.37-15.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.54,175.75,241,181.25s5.28-38,14.11-56.23c6.9-14.25,12.2-13.11,13.6.19S271.54,175.75,271.54,175.75Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.54,175.75,241,181.25s5.28-38,14.11-56.23c6.9-14.25,12.2-13.11,13.6.19S271.54,175.75,271.54,175.75Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.48,177.84c1-7.14,2.3-14.22,3.76-21.27s2.95-14.13,5.53-20.87c-3.38,13.75-5.76,28.43-9.29,42.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.13,136.79a37,37,0,0,1-.27,4.71,6.66,6.66,0,0,1,.27-4.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.54,175.75c-1.19-13.13-1.29-27.05-2-40.22,2.08,13.27,2.16,26.81,2,40.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9,136.91a6.51,6.51,0,0,1-.71,4.57,30.79,30.79,0,0,1,.71-4.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.54,131c.28-.75.56-1.47.85-2.18a15.51,15.51,0,0,0,5.74-8.79,12,12,0,0,0,.25-2.25,13,13,0,0,1,1.16-1.31,14.08,14.08,0,0,1-2,8.1A21.09,21.09,0,0,1,252.54,131Zm18.57,34.64c-3.19,1.89-7.56,1.3-10.86,0-3.53-1.37-7.18-5-5.7-9.13.75-2.1,2.57-3.6,4.08-5.17a10.69,10.69,0,0,0,2.65-4.21,5,5,0,0,0-.54-4.42,6.92,6.92,0,0,0-4.72-2.4,11.33,11.33,0,0,0-6.91,1.27c-.16.56-.32,1.13-.47,1.69a10.37,10.37,0,0,1,6.63-1.83c1.6.12,3.56.63,4.53,2a4.16,4.16,0,0,1,.08,4c-1.33,3.17-4.65,4.86-6.15,7.92a7.66,7.66,0,0,0,1.62,8.5c2.4,2.53,6,3.75,9.45,4.05a12.08,12.08,0,0,0,6.37-1C271.15,166.58,271.13,166.14,271.11,165.68Zm-1-19.49c0-.75-.08-1.51-.13-2.26-.8-1.17-1.59-2.34-2.31-3.57a17.83,17.83,0,0,1-2.8-9.68,21.89,21.89,0,0,1,3-10.21c-.13-.56-.28-1.08-.44-1.55a22,22,0,0,0-2.35,4.77,19.61,19.61,0,0,0-.81,11.94C265.4,139.57,267.88,142.84,270.14,146.19ZM255.76,170.4A9.72,9.72,0,0,0,249,175a8.13,8.13,0,0,0-1.17,5l1.18-.21c0-.08,0-.15,0-.23-.22-3.25,2.27-6.37,5.2-7.51,3.65-1.43,7.81-.33,11.18,1.33a31.36,31.36,0,0,1,4.41,2.67l1.61-.29C266.83,172.38,261.43,169.42,255.76,170.4Zm2.83-45.79a14.08,14.08,0,0,0,2-8.1,13,13,0,0,0-1.16,1.31,12,12,0,0,1-.25,2.25,15.51,15.51,0,0,1-5.74,8.79c-.29.71-.57,1.43-.85,2.18A21.09,21.09,0,0,0,258.59,124.61Zm12.52,41.07c-3.19,1.89-7.56,1.3-10.86,0-3.53-1.37-7.18-5-5.7-9.13.75-2.1,2.57-3.6,4.08-5.17a10.69,10.69,0,0,0,2.65-4.21,5,5,0,0,0-.54-4.42,6.92,6.92,0,0,0-4.72-2.4,11.33,11.33,0,0,0-6.91,1.27c-.16.56-.32,1.13-.47,1.69a10.37,10.37,0,0,1,6.63-1.83c1.6.12,3.56.63,4.53,2a4.16,4.16,0,0,1,.08,4c-1.33,3.17-4.65,4.86-6.15,7.92a7.66,7.66,0,0,0,1.62,8.5c2.4,2.53,6,3.75,9.45,4.05a12.08,12.08,0,0,0,6.37-1C271.15,166.58,271.13,166.14,271.11,165.68Zm-1-19.49c0-.75-.08-1.51-.13-2.26-.8-1.17-1.59-2.34-2.31-3.57a17.83,17.83,0,0,1-2.8-9.68,21.89,21.89,0,0,1,3-10.21c-.13-.56-.28-1.08-.44-1.55a22,22,0,0,0-2.35,4.77,19.61,19.61,0,0,0-.81,11.94C265.4,139.57,267.88,142.84,270.14,146.19ZM255.76,170.4A9.72,9.72,0,0,0,249,175a8.13,8.13,0,0,0-1.17,5l1.18-.21c0-.08,0-.15,0-.23-.22-3.25,2.27-6.37,5.2-7.51,3.65-1.43,7.81-.33,11.18,1.33a31.36,31.36,0,0,1,4.41,2.67l1.61-.29C266.83,172.38,261.43,169.42,255.76,170.4Z",
    style: {
      fill: "#030402",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.23 177.82 239.98 184.72 240.58 183.43 238.6 182.23 239.06 181.25 238.54 178.32 273 172.62 272.37 173.98 273.89 175.34 273.16 176.5 274.23 177.82",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.23 177.82 239.98 184.72 240.58 183.43 238.6 182.23 239.06 181.25 238.54 178.32 273 172.62 272.37 173.98 273.89 175.34 273.16 176.5 274.23 177.82",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.17,123.3c-3.47.75-10.58-3.46-12.95-8.45-.16-.34.55-3.8,1.22-8,.39-2.58.77-5.46.92-8.12,0-.54,16.41,5,16.41,5a42.24,42.24,0,0,0-2.2,10.09,6.55,6.55,0,0,0,.05,1.1.9.9,0,0,1,0,.18C282.85,117.16,282.89,122.5,279.17,123.3Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.63,114.89s0,.12,0,.18a10.89,10.89,0,0,1-1.71,0c-9.79-.79-11.66-13.2-12-16.34,2.93.6,15.82,5,15.82,5a42.52,42.52,0,0,0-2.2,10.11A5.56,5.56,0,0,0,282.63,114.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.29,79.08c-2,5.85.63,23,4.72,27,5.93,5.7,15.89,6.53,20.8-.66,4.75-7,1-29.27-3.64-32.87C282.41,67.2,270.21,70.43,267.29,79.08Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.59,82.6c-1-2-2.29-5.74-3.75-6.95s-.95,2-3.31,2.39c-2.71.45-5.08-2.18-7.66-2.89s-6.24,3.32-6.12,7,.61,8.68.18,11.32-5,4.56-5,4.56-5.56-15.8-.27-23.21,18.29-6.56,21.73-2.87S293.59,82.6,293.59,82.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,89.85s-.09.07-.08.12c.21,1.15.25,2.5-.74,3,0,0,0,.08,0,.06C284.47,92.71,284.4,90.91,284,89.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.8,88.8c-1.88.13-1.47,3.88.27,3.76S284.38,88.68,282.8,88.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.39,89.26s.1,0,.1.1c.09,1.16.39,2.48,1.48,2.76,0,0,0,.06,0,.06C290.66,92.14,290.29,90.38,290.39,89.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.3,87.94c1.85-.35,2.4,3.39.68,3.71S289.74,88.22,291.3,87.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.14,87.24a15,15,0,0,0,1.4-.67,2.52,2.52,0,0,0,1.29-.95.79.79,0,0,0-.23-1,2,2,0,0,0-2,0,2.89,2.89,0,0,0-1.53,1.43A.85.85,0,0,0,281.14,87.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.55,85.89a13.3,13.3,0,0,1-1.54-.23,2.46,2.46,0,0,1-1.52-.53.79.79,0,0,1-.05-1,2,2,0,0,1,1.92-.58,2.89,2.89,0,0,1,1.88.92A.85.85,0,0,1,292.55,85.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.45,100.57c.29.25.6.61,1,.61a3,3,0,0,0,1.23-.38s.07,0,.05.06a1.57,1.57,0,0,1-1.43.73,1.23,1.23,0,0,1-1-1C283.31,100.56,283.4,100.53,283.45,100.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.42,97a4,4,0,0,0,2.78,1.57,4.9,4.9,0,0,0,1.43,0l.27,0,.26-.06a.29.29,0,0,0,.21-.28h0a.6.6,0,0,0,0-.12h0V97.9c0-.9-.22-2.26-.22-2.26.34.14,2.06.78,2,.31A59.47,59.47,0,0,0,288.72,84a.11.11,0,0,0-.21,0c.34,3.74,1.34,7.39,1.75,11.14a6.9,6.9,0,0,0-1.92-.43c-.12,0,.41,2.62.39,3v0a5.54,5.54,0,0,1-4.21-1C284.43,96.81,284.34,96.9,284.42,97Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.07,98.11a4.77,4.77,0,0,1-1.78,1.6,2.13,2.13,0,0,1-1.28.17c-.95-.18-1-1-.92-1.77a5.11,5.11,0,0,1,.34-1.15A6.14,6.14,0,0,0,288.07,98.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.29,99.71a2.13,2.13,0,0,1-1.28.17c-.95-.18-1-1-.92-1.77A2.19,2.19,0,0,1,286.29,99.71Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.18,96.49a4.92,4.92,0,1,1,4.69-6.19h0a4.92,4.92,0,0,1-3.48,6A5,5,0,0,1,282.18,96.49Zm-.11-9.18a4.21,4.21,0,0,0-1.05.14,4.28,4.28,0,1,0,1.05-.14Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.37,95c-1.88,0-3.61-1.89-3.94-4.43A5.83,5.83,0,0,1,290,87a3.06,3.06,0,0,1,5.2-.67,5.91,5.91,0,0,1,1.47,3.28c.35,2.69-1,5.09-3,5.35Zm-.61-9.15-.25,0a2.62,2.62,0,0,0-1.92,1.47,5.19,5.19,0,0,0-.51,3.14c.3,2.33,1.88,4.06,3.53,3.84S296.34,92,296,89.69a5.21,5.21,0,0,0-1.3-2.91A2.7,2.7,0,0,0,292.76,85.83Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.78,90.88l-.48-.44c.66-.72,2.26-1.78,3.62-.66l-.42.51C288.29,89.28,286.84,90.82,286.78,90.88Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.21,95l-.62-.22c.11-.29,1.06-2.83,2.49-3.25s10.18-.71,10.56-.72l0,.65c-2.54.09-9.36.39-10.39.7S265.46,94.26,265.21,95Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.19,93.31s-3.81-5.56-6.33-4.2.3,9.38,3.24,10.51a3,3,0,0,0,4-1.57Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.73,91.39c-.05,0-.06.06,0,.08,2.05.85,3.12,2.78,3.86,4.77a1.64,1.64,0,0,0-2.46-.48.06.06,0,0,0,.05.11,1.83,1.83,0,0,1,2,.67,8.64,8.64,0,0,1,.95,1.64c.1.19.43.09.36-.12v0C270.56,95.38,268.55,91.68,265.73,91.39Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.73,260.73c-.6-2.35-37.32-58.82-40-60.05-.31-.16-19.36,11.44-19.36,11.44-.82.95-34.75-8.8-34.75-8.8l-3.32,41.55L520.15,248s8.12,5.59,15.59,10.2h0a94.59,94.59,0,0,0,9.84,5.67C548.7,264.93,555.34,263.06,554.73,260.73Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.94,251.91c2.85,1.89,6.39,4.2,9.8,6.32h0c4.58,2.86,8.67,5.28,9.85,5.67,3.07,1,9.71-.84,9.1-3.18s-37.3-58.82-40-60.05c-.25-.11-11.8,6.87-16.94,10,9.28,9.88,33.39,35.82,37.61,42.46C540.28,260.83,527.63,253,525.94,251.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.15,194.56s-52.7-24.56-76.29-24.43c-28.06.16-50.07,33.32-15.83,57.55,30.27,21.42,127,19.63,127,19.63l-21.94-37.53a184.32,184.32,0,0,0-62.15-13.72l48.31,10.14Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.51,259.42c.7-2.31,40.08-57,42.83-58.07.31-.15,18.79,12.36,18.79,12.36.77,1,35.13-7.14,35.13-7.14l1.33,41.66-62.94.14s-8.38,5.2-16.06,9.45h0a94.43,94.43,0,0,1-10.11,5.2C376.33,263.91,369.79,261.72,370.51,259.42Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.46,263a95.68,95.68,0,0,0,10.1-5.2h0c1.76-1,3.57-2,5.3-3-1.74.9-15.05,7.71-9.53.43,5.92-7.8,44.94-42.77,44.94-42.77-4.68-3.15-16.71-11.24-17-11.12-2.76,1.09-42.13,55.75-42.83,58.08S376.33,263.91,379.46,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.86,193.75s47.22-16.59,75.66-13.19c27.86,3.32,39.29,38.26,12.12,57.19C527,258.42,423.27,248.33,423.27,248.33l20.53-36.75s39.46-11.5,74.15-11.15l-48.75,7.82Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.21,193.62s55.95-21.49,84-11.46,22.9,44.27,7.09,53.86S546.1,244.6,504,255.23c-16.36,4.14-46.5,4.84-54.95,3.8-30.76-3.8-33.15-20.84-62.8-26.6-1.1-.21-29.55-15.05-24.39-37.84s26.24-28.4,50.87-22.06C438.12,179.08,469.21,193.62,469.21,193.62Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.29,185.41v0a2.92,2.92,0,0,1-1.21,2.37A25.81,25.81,0,0,1,365.29,185.41Zm23.11-2.9a2.94,2.94,0,1,0,2.94,2.94A2.94,2.94,0,0,0,388.4,182.51Zm26,0a2.94,2.94,0,1,0,2.95,2.94A2.94,2.94,0,0,0,414.44,182.51Zm26.05,0a2.94,2.94,0,1,0,2.95,2.94A2.94,2.94,0,0,0,440.49,182.51ZM490,186.89a3,3,0,0,0,5.52-1.44v0C493.63,185.89,491.78,186.39,490,186.89Zm28.62-4.38a2.94,2.94,0,1,0,3,2.94A2.94,2.94,0,0,0,518.63,182.51Zm26,0a2.94,2.94,0,1,0,3,2.94A2.94,2.94,0,0,0,544.68,182.51ZM388.4,222.31a2.95,2.95,0,1,0,2.94,2.95A2.95,2.95,0,0,0,388.4,222.31Zm26,0a2.95,2.95,0,1,0,2.95,2.95A2.95,2.95,0,0,0,414.44,222.31Zm26.05,0a2.95,2.95,0,1,0,2.95,2.95A2.95,2.95,0,0,0,440.49,222.31Zm26.05,0a2.95,2.95,0,1,0,2.94,2.95A2.94,2.94,0,0,0,466.54,222.31Zm26,0a2.95,2.95,0,1,0,2.94,2.95A2.95,2.95,0,0,0,492.59,222.31Zm26,0a2.95,2.95,0,1,0,3,2.95A2.95,2.95,0,0,0,518.63,222.31Zm26,0a2.95,2.95,0,1,0,3,2.95A2.95,2.95,0,0,0,544.68,222.31Zm26.05,0a2.94,2.94,0,0,0-2.17,4.94,32.4,32.4,0,0,0,2.35-4.93ZM375.37,202.55a2.95,2.95,0,1,0,2.95,2.95A2.95,2.95,0,0,0,375.37,202.55Zm0,0a2.95,2.95,0,1,0,2.95,2.95A2.95,2.95,0,0,0,375.37,202.55Zm26.05,0a2.95,2.95,0,1,0,2.94,2.95A2.94,2.94,0,0,0,401.42,202.55Zm26.05,0a2.95,2.95,0,1,0,2.94,2.95A2.95,2.95,0,0,0,427.47,202.55Zm26,0a2.95,2.95,0,1,0,2.94,2.95A2.95,2.95,0,0,0,453.52,202.55Zm26,0a2.95,2.95,0,1,0,2.95,2.95A2.95,2.95,0,0,0,479.56,202.55Zm26.05,0a2.95,2.95,0,1,0,2.94,2.95A2.95,2.95,0,0,0,505.61,202.55Zm26,0a2.95,2.95,0,1,0,2.94,2.95A2.95,2.95,0,0,0,531.66,202.55Zm26.05,0a2.95,2.95,0,1,0,2.94,2.95A2.95,2.95,0,0,0,557.71,202.55ZM427.47,242.36a2.94,2.94,0,1,0,2.94,2.94A2.94,2.94,0,0,0,427.47,242.36Zm26,0a2.94,2.94,0,1,0,2.94,2.94A2.94,2.94,0,0,0,453.52,242.36Zm26,0a2.94,2.94,0,1,0,2.95,2.94A2.94,2.94,0,0,0,479.56,242.36Zm26.05,0a2.94,2.94,0,1,0,2.94,2.94A2.94,2.94,0,0,0,505.61,242.36Zm26,0a2.94,2.94,0,0,0,0,5.88h0c.51-.15,1-.28,1.5-.41h0a2.94,2.94,0,0,0-1.51-5.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.56,208.92a102.3,102.3,0,0,0,23.32,1.1,127.17,127.17,0,0,0,22-3.49c6.93-1.74,13.72-3.95,20.52-6.12a207.28,207.28,0,0,1,20.43-5.63,89.09,89.09,0,0,1,20.77-2.14q1.3,0,2.61.12a.07.07,0,1,1,0,.13,84.14,84.14,0,0,0-21,2.48c-6.94,1.63-13.71,3.89-20.49,6.06s-13.58,4.43-20.49,6.26a106.44,106.44,0,0,1-21.92,3.63,104,104,0,0,1-23.11-1.53c-.94-.16-1.88-.34-2.81-.54C422.24,209.21,422.34,208.89,422.56,208.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.12,201.44a83.74,83.74,0,0,0,11.27,3.07c3.79.83,7.59,1.68,11.42,2.32a59.94,59.94,0,0,0,6.78.9c.09,0,.08.15,0,.14-2-.13-3.92-.18-5.88-.29s-4-.38-5.93-.68a57.54,57.54,0,0,1-11.41-3c-2.1-.79-4.18-1.62-6.26-2.44C424.08,201.47,424.09,201.43,424.12,201.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.3,225.7a36.31,36.31,0,0,1,11.79,5.37,131.58,131.58,0,0,1,10.56,8.31,107.32,107.32,0,0,0,10.7,8.18,40.1,40.1,0,0,0,14.16,5.67,76.69,76.69,0,0,0,18.6.86c.05,0,.05.06,0,.07-10.6.76-22,.74-31.65-4.42-8-4.32-14-11.46-21-17-3.91-3.08-8.26-5.76-13.16-6.87C403.17,225.81,403.21,225.68,403.3,225.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.74,249.32c5.63.47,11.28.56,16.93.65s11.29,0,16.93-.28c3.22-.18,6.47-.44,9.66-.93a.07.07,0,0,1,0,.14c-5.63.68-11.23,1.45-16.9,1.82a118.38,118.38,0,0,1-16.95-.05c-3.24-.25-6.48-.64-9.7-1.07C447.56,249.58,447.56,249.3,447.74,249.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.17,196.52a75.75,75.75,0,0,0,10.54.58,77.49,77.49,0,0,0,10.55-.73,43.58,43.58,0,0,0,5.89-1.19c.08,0,.12.1,0,.13a76.54,76.54,0,0,1-10.48,2.42A47.78,47.78,0,0,1,447,198a53.52,53.52,0,0,1-5.91-1C440.84,196.93,440.91,196.48,441.17,196.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.25,131.54a.54.54,0,0,0,.44.57l2.23.15c2-5.2,4.15-9.33,3.59-7.72a26.83,26.83,0,0,0-1.4,7.85c1,.06,3.26.17,4.4.22,1.74-9.15,4-15.94,3.82-13.84-.56,8.45-.06,11.16.53,14.07,10.62.49,24.55,1,34.63,1.15,1.17-5.06,2.19-10.54,2.36-10.16,1.37,2.86,1.75,7,1.78,10.21,3.21,0,5.77,0,7.33-.12,0,0,.75-4.26.86-5.66a29.14,29.14,0,0,0-1.12-10.66,52.32,52.32,0,0,0-4.66-9.9.25.25,0,0,0,0-.07s0,0,0,0a29.79,29.79,0,0,1-2.68-6.61s0,0,0,0a30.15,30.15,0,0,1-.83-5.07c-.46-6.25-4-11.66-9.85-13.31C467.52,72.11,456.4,76.49,453,84.5c-.32.78-.64,1.68-.94,2.66v0c-1.14,3.61-2.16,8.3-3.1,11.92,0,0,0,0,0,0s0,0,0,0h0a33,33,0,0,1-1.32,4.18C444.85,109.88,438.44,113.58,437.25,131.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.17,84.29A11.82,11.82,0,0,1,488,93.81a30.61,30.61,0,0,0,1.54,7.76,27.26,27.26,0,0,0,4.44,6.84c2.72,3.38,4.62,6.74,5,11.22s.21,9.91-1.33,14.15a0,0,0,0,1,0,0,36.49,36.49,0,0,0,.52-14.77c-.84-5-3.64-8.06-6.51-11.83a20.78,20.78,0,0,1-4.21-10.11c-.28-2.25-.25-4.6-1.15-6.72-1.09-2.54-3.25-4.15-5.39-5.59A.27.27,0,0,1,481.17,84.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.19,110.35c2.72-3.54,5.55-6.56,7.15-11,1.45-4,2.28-8.23,3.76-12.23,0-.07.12,0,.1,0-2.28,7.1-2.72,14.27-7.31,20.24-2.5,3.25-5,6.25-6.64,10.14a34.83,34.83,0,0,0-2.59,12.85c0,.16-.2.15-.22,0A28.7,28.7,0,0,1,441.19,110.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.62,82c-1.56-.58-3-9.27,2.68-13.4s13,.59,9.95,7.7C489.31,80.78,481.91,83.2,478.62,82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.28,68.06a9.75,9.75,0,0,1,3.29,5.51,5.88,5.88,0,0,1-1.73,5.6,11.91,11.91,0,0,1-5.67,2.77,17.82,17.82,0,0,1-3.26.4,8.94,8.94,0,0,1-3.29-.36,8,8,0,0,0,3.26,1,14.76,14.76,0,0,0,3.45-.06,11.38,11.38,0,0,0,6.36-2.83A6.79,6.79,0,0,0,493.57,77a6.86,6.86,0,0,0-.06-3.6A8.64,8.64,0,0,0,489.28,68.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.46,137.54c-14.94,16.79-35,32.19-40.95,33.8-7.52,2-43.12-8.53-44.84-9.24-4.26-1.8,7.22-30.33,11.85-28.6,7.05,2.64,30.89,12.84,33.12,12.16s15.29-6.17,33.42-14.8C477.59,124.89,481.73,127.12,472.46,137.54Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.82,162.24c-3.53-.34-19.59-3.35-23.86-5.19s-16.22-8-15.14-11.43,4.71-1.89,4.71-1.89-4.63-3.41-3.23-6.75,7-.78,7-.78-4.49-3.85-2.86-7.08,6.81.28,6.81.28-4.28-3.32-1.81-5.43c3-2.52,10.15,4.49,15,6.17,1.1.38,23,6.1,23,6.1Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.77,129.11c5.29,5.14,8.5,6.48,15.62,8a.12.12,0,0,1,0,.23c-7.1-.84-11.37-1.93-15.87-8C360.28,129.05,360.52,128.86,360.77,129.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.86,135.78c6,4.87,9.44,6.35,16.77,8.47.11,0,.07.21,0,.18-7.37-1.47-11.6-2.66-16.93-8.31C356.42,135.86,356.59,135.56,356.86,135.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.91,143.82c6.11,4.3,9.85,6.08,17.23,7.23a.14.14,0,0,1,0,.27c-7.65-.43-12.32-2.63-17.32-7.3C353.45,143.7,353.52,143.55,353.91,143.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.3,134.87s-6-7-9.37-9.5-19.18-7.23-20.39-3.86c-1.57,4.34,7,8.87,11.54,10.54,0,0-3.64,10,1.84,14.63S402.3,134.87,402.3,134.87Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.5,122.84c1.42,5,7.48,6.8,11.73,8.75a.42.42,0,0,1,.16.68c-1.25,4.31-1.75,10.76,1.24,14.44a.11.11,0,0,1-.16.15c-3.73-3.51-3.76-9.88-2.09-14.52-4.39-1.93-10.39-4-10.93-9.49A0,0,0,0,1,372.5,122.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.38,194.31l-69.33,1.16,3.45-22.17s-5.63-4.88-2.35-14.15c2.15-6.07,11.87-20.28,16.79-26.2,12-14.41,20.29-6.36,23.62-2.66C500.24,144.45,515.38,194.31,515.38,194.31Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,195.47l69.34-1.15s-4.22-13.91-10.08-29.13c-3.34-1-8.89-3-12.47-5.84-5.4-4.34-10.58-16.82-10.58-16.82l-24.08-1.92c-4.58,6.5-9.56,14.41-11,18.53-3.28,9.28,2.35,14.16,2.35,14.16Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.48,145.65a2.94,2.94,0,1,1-2.94-3A2.94,2.94,0,0,1,469.48,145.65Zm-2.94,36.86a2.94,2.94,0,1,0,2.94,2.94A2.93,2.93,0,0,0,466.54,182.51Zm26,0a2.94,2.94,0,1,0,2.94,2.94A2.94,2.94,0,0,0,492.59,182.51Zm-39.07-19.76a2.95,2.95,0,1,0,2.94,2.94A2.95,2.95,0,0,0,453.52,162.75Zm26,0a2.95,2.95,0,1,0,2.95,2.94A2.94,2.94,0,0,0,479.56,162.75Zm25.73,2.44c-.7-.21-1.49-.46-2.35-.75a2.9,2.9,0,0,0-.28,1.25,3,3,0,0,0,2.95,2.95,2.83,2.83,0,0,0,.93-.15C506.13,167.4,505.72,166.3,505.29,165.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.45,173.11a61,61,0,0,0-9.07-.16c-1.51.11-3,.29-4.48.5-.75.1-1.49.18-2.23.25a9.73,9.73,0,0,1-2.35,0,.05.05,0,1,0,0,.1,14.92,14.92,0,0,0,2.19.36,17.3,17.3,0,0,0,2.16,0c1.52-.1,3-.26,4.57-.37,3.07-.22,6.14-.44,9.22-.44C470.58,173.36,470.59,173.12,470.45,173.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.31,177.07a65.42,65.42,0,0,0-7.3-1.69c-1.23-.21-2.47-.35-3.71-.45-.6-.05-1.19-.09-1.79-.12s-1.32,0-2,0c-.07,0-.09.1,0,.11.62.06,1.23.22,1.84.32l1.84.28c1.23.2,2.46.4,3.7.58,2.46.37,4.92.75,7.37,1.2C477.41,177.3,477.43,177.1,477.31,177.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.82,133.46c20.6,20.75,42.5,56.67,37.71,65.56-5.33,9.9-29.95-11.4-29.84-13.1.08-1.29-10.06-27.86-17.75-47.18S488.73,128.32,493.82,133.46Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.53,189c-1.16-3.33-2.37-6.63-3.6-9.93s-2.48-6.58-3.72-9.88l-3.84-9.83-1.95-4.9c-.67-1.63-1.33-3.26-2-4.89.57,1.67,1.18,3.32,1.77,5l1.82,4.95,3.73,9.88c1.28,3.28,2.53,6.56,3.83,9.83S502.17,185.7,503.53,189Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.2,157.2a18.6,18.6,0,0,0-1.39-2.41c-.25-.38-.51-.76-.79-1.13s-.55-.74-.84-1.11a12.34,12.34,0,0,0,1.31,2.46A16.33,16.33,0,0,0,491.2,157.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.1,199.83c-5.77,6.07-17.53,5.91-50.68,7.38-4.59.2-15.64-32.45-10.75-32.92,6.15-.59,30.17-1.55,31.93-1.4C516.49,174.17,535,195.71,531.1,199.83Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.76,175.34s-12.28-2.56-20.39-3.85c-4.52-.73-12.39-1.27-15.95-.28-5.34,1.48-26.7,11.07-24.49,16.3,2,4.74,19.32-5.84,19.32-5.84s-18.41,9.13-14.95,14.39,21.43-9.3,21.43-9.3-18.7,9.81-14.28,14.66c3.35,3.67,20.36-8.59,20.36-8.59s-16,8.54-12.73,12.46c3.62,4.33,20-6,20-6,10,8.57,18.29,8.55,24.17,7.84C484.71,207,480.76,175.34,480.76,175.34Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.41,178.11c-2.2,1-4.44,2-6.54,3.17s-4.17,2.44-6.16,3.82a41,41,0,0,0-7.21,6.09c4.14-3.8,11.61-8.16,13.71-9.35s4.15-2.47,6.25-3.65C445.51,178.16,445.46,178.08,445.41,178.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.83,185.63c-2.75,1.39-5.54,2.67-8.24,4.18s-5.09,3.17-7.66,4.86c-.2.13-.07.19.14.07,2.63-1.58,5.19-2.84,7.85-4.39s5.25-3.21,7.95-4.66C449.91,185.67,449.87,185.61,449.83,185.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.79,191.41a68.66,68.66,0,0,0-12.11,7.36c-.19.13,0,.2.2.07,4-2.52,7.08-4.53,12-7.28C454.93,191.51,454.88,191.37,454.79,191.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.4,179.72a28.41,28.41,0,0,0-19-6.9c-.09,0-.1.14,0,.14,7.15.43,16.44,5,19,6.87C516.39,179.88,516.46,179.77,516.4,179.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.52,127.93c-.21,1.3-5.77,10-11.61,10.07-1.91,0-2.53-10.36-2.53-10.36l-.22-.75-3.1-10.59,12.1-8.91,1.75-1.18s.66,3,1.44,6.63c0,.17.07.34.11.53s.1.4.13.59c.13.55.25,1.11.36,1.67s.18.85.25,1.3.16.89.25,1.34A70.61,70.61,0,0,1,481.52,127.93Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.35,112.84a22.14,22.14,0,0,1-12.19,14l-3.1-10.59,12.1-8.91,1.75-1.18S478.57,109.16,479.35,112.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.06,99.83c-1.66,19.28,9.71,22.45,13.86,22.81,3.78.32,16.67.93,20.32-18.08s-4.8-25.88-13.4-27.07S449.72,80.55,448.06,99.83Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.07,96.73a12,12,0,0,0,1.32-.19,2.16,2.16,0,0,0,1.31-.45.69.69,0,0,0,.05-.84,1.67,1.67,0,0,0-1.65-.5,2.47,2.47,0,0,0-1.63.78A.73.73,0,0,0,451.07,96.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.43,97c-.45-.09-.85-.24-1.29-.36A2.19,2.19,0,0,1,461.9,96a.69.69,0,0,1,.05-.84,1.72,1.72,0,0,1,1.71-.29,2.47,2.47,0,0,1,1.51,1A.74.74,0,0,1,464.43,97Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,102.08s.1.07.09.13c-.15,1.31-.11,2.83,1,3.37,0,0,0,.08,0,.07C460.63,105.32,460.59,103.3,461,102.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.24,100.81c2.13,0,1.93,4.28,0,4.26S460.46,100.79,462.24,100.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.07,101.08c.36.26.7.7,1.15.77s.92-.36,1.28-.77c0,0,.07,0,.07.06,0,.81-.38,1.63-1.26,1.71s-1.34-.68-1.5-1.5C462.78,101.19,462.92,101,463.07,101.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.65,101.45s-.11.06-.11.12c0,1.31-.24,2.82-1.45,3.21a0,0,0,0,0,0,.08C453.56,104.71,453.85,102.71,453.65,101.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.53,100c-2.11-.24-2.45,4-.49,4.22S454.3,100.24,452.53,100Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.62,100.24c-.35.2-.71.58-1.12.58s-.77-.5-1-1c0,0-.07,0-.07,0-.09.81.11,1.67.88,1.89s1.28-.45,1.53-1.25C451.86,100.4,451.76,100.16,451.62,100.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.58,112.9c-.31.3-.63.73-1.11.77a3.48,3.48,0,0,1-1.41-.34,0,0,0,0,0-.06.07,1.78,1.78,0,0,0,1.67.72,1.4,1.4,0,0,0,1-1.16C460.73,112.88,460.63,112.85,460.58,112.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.37,107.81s-.39,2-.45,2.88c0,.08.22.14.53.18h0a4.42,4.42,0,0,0,4.38-1.39.1.1,0,0,0-.13-.14,6.56,6.56,0,0,1-4.09.91c0-.26.77-3.31.63-3.33a8.22,8.22,0,0,0-2.14.35c.7-4.08,2-8,2.67-12.09,0-.15-.19-.21-.24-.08A66.66,66.66,0,0,0,453.15,108C453,108.53,455,108,455.37,107.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.62,110.43a5.46,5.46,0,0,0,1.91,1.94,2.42,2.42,0,0,0,1.44.28c1.09-.14,1.25-1.1,1.16-2a5.56,5.56,0,0,0-.3-1.33A7,7,0,0,1,455.62,110.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.53,112.37a2.42,2.42,0,0,0,1.44.28c1.09-.14,1.25-1.1,1.16-2A2.48,2.48,0,0,0,457.53,112.37Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.53,105.06c-4-.36-3.48-9.61-3.48-9.61s-6.71-1.81-9.16-6.66c0,0,1.57,4.16,4.11,6,.42.31-13.29-2.18-13.76-12.89,0,0-2.86,10.31-9.33,12-.31.08,1.69-9,4.57-11.63a37.25,37.25,0,0,1,3.53-3,19.85,19.85,0,0,1,14.8-2.61c8.39,1.91,13.25,11.28,13.6,15C486.11,98.94,482.44,105.24,480.53,105.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.54,95c-7.51-.93-13.14-6.22-13.16-14a.17.17,0,0,0-.33,0c-1.64,7.74,6.36,14.15,13.55,14.15C471.77,95.14,471.71,95,471.54,95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.55,104.63c-3.92-2.42-4.25-6.58-4.23-10.78,0-.12-.21-.14-.22,0-.38,4.08,0,9.16,4.27,11.13A.19.19,0,0,0,480.55,104.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.29,80.32a0,0,0,0,0-.07,0c-1.26,4.25-2,11.52-7.64,12.18a.12.12,0,0,0,0,.23C456,92.58,458.53,84.84,458.29,80.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.94,111.67a4.11,4.11,0,0,1-.9.23,2.81,2.81,0,0,1-.91,0,2.51,2.51,0,0,1-1.11-.36,3.06,3.06,0,0,1-.74-.56,3.72,3.72,0,0,1-.73-1.09l1.07-5.17s4.22-6,7-4.54S484.16,110.47,480.94,111.67Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.61,102.69c.05,0,.06.07,0,.08-2.26.92-3.44,3-4.27,5.18a1.8,1.8,0,0,1,2.7-.49c.06,0,0,.13-.06.12a2,2,0,0,0-2.22.7,10.13,10.13,0,0,0-1.06,1.8c-.1.2-.47.09-.39-.14,0,0,0,0,0,0C478.29,107,480.52,103,483.61,102.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.25,142.53s-1.63-10.24,1.57-15.64l-1.57-1s-3.58,2.59-2.42,16.39Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.82 140.82 467.26 129.41 465.5 130.22 458.17 140.61 460.82 140.82",
    style: {
      fill: "#7D6DE5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.18,381.18c-2.79,1-85.32,2.64-88.43.75-.36-.2-1.71-27.5-1.71-27.5.1-.39-1.28-3-3.38-6.68-5.89-10.27-17.39-28.66-17.39-28.66l49-14.81,20.13,40.3,5.13,10.29s11.25,4.4,21.06,8.78l0,0c6,2.69,11.3,5.16,12.53,6.08C333.29,372.18,336,380.2,333.18,381.18Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.18,381.18c-2.79,1-85.32,2.64-88.43.75-.36-.2-1.71-27.5-1.71-27.5.1-.39-1.28-3-3.38-6.68l51.72-3.17,5.13,10.29s11.25,4.4,21.06,8.78l0,0c6,2.69,11.3,5.16,12.53,6.08C333.29,372.18,336,380.2,333.18,381.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.53,381.49c-2.87,1-85.52,2.44-88.7.5-1.22-.73-2.67-13.45-1.78-27.56l53.28-.85s30.86,13.64,34.12,16.14S336.4,380.48,333.53,381.49Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.83,382c1.16.71,12.9,1,27.49,1l-28-28.54h0l-1.3,0C242.16,368.54,243.62,381.26,244.83,382Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.29,378.21c-13.86-.11-69.77.79-83.48,1.74-.11,0-.11.08,0,.09,13.73.4,69.63-1,83.48-1.61C332.58,378.42,332.58,378.21,332.29,378.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.08,366.84a11.12,11.12,0,0,0-8.23,3.52,10.8,10.8,0,0,0-3,7.45c0,.08.15.08.16,0a12.87,12.87,0,0,1,11-10.8A.09.09,0,1,0,325.08,366.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.7,354.89c-5.55,0-11.94,2.09-15.31,6.68-.13.18.12.36.29.28a76.94,76.94,0,0,1,15.12-6.28A.35.35,0,0,0,300.7,354.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,356.49c-5.55,0-11.94,2.08-15.31,6.68-.13.18.12.36.28.27a76.64,76.64,0,0,1,15.13-6.27A.35.35,0,0,0,305,356.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.32,358.08c-5.55,0-11.95,2.09-15.31,6.68-.13.18.12.36.28.28a77,77,0,0,1,15.13-6.28A.35.35,0,0,0,309.32,358.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.63,359.68c-5.55,0-11.95,2.08-15.31,6.68-.13.18.12.36.28.27a76.39,76.39,0,0,1,15.13-6.27A.35.35,0,0,0,313.63,359.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.11,366.73c-6.22.13-6,9.79.19,9.67S258.34,366.61,252.11,366.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.44,340c-2.85-2.28-6.35.06-8,2.51a29.16,29.16,0,0,0-4.79,14.26c0,.12.08.16.17.16a.68.68,0,0,0,1,.43c3.9-2.8,8.42-5.31,11.34-9.22C307.84,345.84,309.13,342.15,306.44,340Zm-6.6,11.91c-1.89,1.42-3.83,2.74-5.67,4.23.95-2.78,1.77-5.58,3-8.27a31.32,31.32,0,0,1,2-3.77c1.17-1.86,6.54-6.58,7.19-.56C306.67,346.85,302.08,350.2,299.84,351.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.87,359.05c4.84.66,9.79-.8,14.53-1.62a.66.66,0,0,0,.39-1,.16.16,0,0,0,0-.24,29.14,29.14,0,0,0-13.54-6.59c-2.92-.51-7,.34-7.41,4C273.5,357,277,358.67,279.87,359.05Zm-3.4-3.1c-3.84-4.69,3.29-5.19,5.44-4.73a32.25,32.25,0,0,1,4.06,1.25c2.77,1,5.35,2.4,8,3.67-2.35.26-4.65.72-7,1.07C284.18,357.62,278.58,358.54,276.47,356Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.93,347.22l58.12-8.81s-27.94-55.67-45.23-85.89c-9.61-16.79-35.92-17.62-48.71,2.51-17.09,26.89-30.35,52.08-38,66L149,322.21l2.84,21.53,43.81,9.82c16.78,2,28.56-27.87,28.84-27.37C226.59,330.12,235.93,347.22,235.93,347.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.77,326.33c-1.65-3.39-2.94-7-4.41-10.45s-2.85-6.71-4.26-10.07c-2.85-6.78-5.8-13.54-8.57-20.36-1.55-3.84-3-7.71-4.42-11.58a.08.08,0,1,0-.15,0q1.68,5.49,3.51,10.93c-.32-.63-.65-1.26-1-1.86-.93-1.67-1.89-3.32-2.86-5,0-.06-.13,0-.1.06q1.33,2.49,2.71,4.95c.46.81,1,1.61,1.45,2.43a255.84,255.84,0,0,0,12.06,29.78c1.84,3.79,4,7.42,5.86,11.21C224.66,326.56,224.83,326.45,224.77,326.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.23,336.89c-2.8-4.33-9.47-17.41-11.86-21.94-4.84-9.15-9.26-18.49-13.44-27.95-2.37-5.35-4.58-10.74-6.77-16.16,0,0-.07,0-.06,0,3.3,9.76,7.22,19.32,11.47,28.7s18,34.7,20.48,37.44C237.14,337.1,237.3,337,237.23,336.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.16,278.07c-5,8.94-10.13,17.82-15.16,26.75q-3.81,6.76-7.6,13.55c-1.18,2.13-2.33,4.29-3.55,6.39a12.06,12.06,0,0,1-4.6,4.77,35.9,35.9,0,0,1-7.28,2.54c-2.83.83-5.64,1.72-8.48,2.5-.13,0-.07.23.06.2,2.53-.68,5.09-1.26,7.64-1.89a66,66,0,0,0,6.92-1.87,11.31,11.31,0,0,0,5.14-3.54,41,41,0,0,0,3.59-6q7.54-13.77,14.94-27.63c2.8-5.25,5.58-10.51,8.42-15.74C201.22,278.06,201.17,278,201.16,278.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.61,339.06c3.48-.63,7-.93,10.56-1.38l10.56-1.37c7-.92,30.93-4.73,32.73-5.33.12,0,.08-.22,0-.22-1.72-.06-17.37,2-20.88,2.55-7,1-14,2.27-21,3.45-2,.34-4,.72-6,1.08s-4,.78-6,1C234.46,338.89,234.49,339.09,234.61,339.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.39,393.62c-1.05-2.77-53.68-66.37-57.13-67.49-.4-.15-22,16.65-22,16.65-.86,1.27-43.54-5.83-43.54-5.83l1.79,51,77-5s10.67,5.67,20.41,10.23c0,0,0,0,0,0,6,2.83,11.29,5.21,12.78,5.53C264.64,399.59,272.46,396.38,271.39,393.62Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.75,398.77c-1.51-.32-6.8-2.7-12.79-5.53h0C238.2,388.67,227.52,383,227.52,383l-17.13,1.11L181.67,342c5.94.79,10.36,1.23,10.63.82,0,0,21.56-16.8,22-16.64,3.45,1.11,56.08,64.71,57.13,67.48S264.64,399.59,260.75,398.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.85,393.69c-1.1-2.84-54-66.39-57.5-67.54-1.35-.44-11.94,6.75-22,16.63l34.13,40.94S256.9,398.2,260.92,399,273,396.53,271.85,393.69Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.55,394.89c-9.12-10.43-44.92-53.38-53.15-64.39-.07-.09,0-.14.07-.06,9.27,10.15,44.72,53.39,53.26,64.31C268.91,395,268.74,395.11,268.55,394.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.24,396.86a11.11,11.11,0,0,1-2.7-8.54,10.74,10.74,0,0,1,3.7-7.11c.07,0,.17.06.11.13a12.87,12.87,0,0,0-1,15.41C255.43,396.84,255.31,396.94,255.24,396.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.27,386.17c-3.6-4.22-6.21-10.41-4.93-16,0-.22.36-.14.4,0a76.45,76.45,0,0,0,5.12,15.56A.35.35,0,0,1,230.27,386.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.29,388.39c-3.6-4.21-6.21-10.41-4.92-16,0-.21.35-.14.39,0A76.87,76.87,0,0,0,234.88,388,.35.35,0,0,1,234.29,388.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.31,390.62c-3.6-4.22-6.21-10.41-4.92-16,.05-.22.35-.14.39,0a77.07,77.07,0,0,0,5.12,15.56A.35.35,0,0,1,238.31,390.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.33,392.84c-3.6-4.21-6.21-10.41-4.92-16,.05-.21.35-.14.39,0a76.87,76.87,0,0,0,5.12,15.56A.35.35,0,0,1,242.33,392.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.54,341.63c-4-4.8,3.48-11,7.45-6.17S211.51,346.43,207.54,341.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.69,394.7c1.06-4.77,0-9.83-.41-14.61a.68.68,0,0,0-1-.48.15.15,0,0,0-.24,0,29.15,29.15,0,0,0-7.68,12.94c-.75,2.88-.24,7.05,3.35,7.72C226.12,400.87,228.08,397.49,228.69,394.7Zm-3.36,3.14c-5,3.43-4.91-3.72-4.28-5.82a32,32,0,0,1,1.59-3.95,84.71,84.71,0,0,1,4.32-7.65c.06,2.36.33,4.69.48,7.05C227.62,390.28,228.08,395.94,225.33,397.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.75,366.7c-2.51,2.65-.47,6.32,1.83,8.21a29.17,29.17,0,0,0,13.83,5.95.14.14,0,0,0,.16-.16.68.68,0,0,0,.52-1c-2.47-4.11-4.6-8.82-8.26-12.06C217.7,365.78,214.12,364.19,211.75,366.7Zm11.32,7.56c1.26,2,2.42,4,3.75,6a87.2,87.2,0,0,1-8-3.66,31.08,31.08,0,0,1-3.6-2.26c-1.75-1.33-6-7.06,0-7.22C218.6,367,221.56,371.88,223.07,374.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.56,324.06s-66-8.86-87.6-3c-30.13,8.11-33.59,44.31-10.38,58.08C105,396.56,207,386.83,207,386.83l-28.47-48s-42.72-8-81-4.88l77.27,9.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,342.08a1.25,1.25,0,0,1-.07-.26l-.06-.22c0-.16-.09-.32-.14-.49-.1-.34-.23-.66-.36-1s-.28-.64-.43-1a8.16,8.16,0,0,0-.56-.88s0,0-.07-.06l-.05,0-.07,0-.07,0c-4.7-.75-36.52-4.35-41.25-4.74s-9.53-.67-14.31-.9a259.33,259.33,0,0,0-28.57.11l-2.67.21c-.19-.06-.39-.09-.59-.14-.46-.1-.92-.2-1.39-.28-.86-.14-1.73-.24-2.6-.35-1.82-.23-3.63-.36-5.44-.65-.11,0-.14.17,0,.19,1.82.36,3.61.86,5.43,1.21l1.58.3c-3.48.35-7,.8-10.42,1.3-.11,0-.1.2,0,.19,4.72-.52,9.5-.76,14.24-.88s9.43-.21,14.15-.12c9.54.19,19.1.72,28.62,1.4,5.35.38,37.8,4.16,43.15,4.17l.07,0c.05.14.1.27.16.4.16.31.32.62.5.93s.33.58.51.86l.28.42.14.2a1.07,1.07,0,0,1,.15.22A.09.09,0,1,0,180.47,342.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.33,383.84c-1.68-2.76-3.14-5.72-4.69-8.57s-3.12-5.73-4.69-8.59c-3.11-5.7-14.25-24.85-15.32-26.18-.07-.09-.2,0-.16.12.55,1.49,7.53,14.19,9.13,17,3.21,5.66,6.56,11.2,9.87,16.78.94,1.6,1.92,3.17,2.88,4.75s2,3.14,2.85,4.77C192.25,384,192.39,383.93,192.33,383.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.89,345.76c-2.84-.62-5.73-1-8.59-1.45l-8.61-1.39q-8.61-1.37-17.24-2.59c-11.47-1.62-23-2.87-34.52-3.58-6.52-.41-13-.57-19.56-.82-.14,0-.12.24,0,.24,11.6.07,23.23,1.3,34.77,2.61s22.83,2.78,34.23,4.39c3.21.45,6.43.92,9.65,1.39s6.54,1.09,9.82,1.41C166,346,166,345.78,165.89,345.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.07,272c6.12,8.19,17.32,11.76,27.22,12.87,10.1,1.12,21.54.74,30.93-3.4a24.53,24.53,0,0,0,10.48-8.23c2.72-4,3.23-8.22.71-12.17-2-3.19-6.68-5.62-6.55-8.44s2.6-4.93,3.38-7.62c1.34-4.58-1.05-8.17-4.2-11.33-7.47-7.51-5.24-17-7.88-26.72-1.85-6.84-12.07-19-27.13-9.24,0,0-7.38,1.57-10.18,8.15-2.45,5.76-.8,14.47-4.15,19.83-2.86,4.56-6.76,5.13-9.51,9.93-1.2,2.08-1.84,4.54.23,9.69.75,1.86,1.5,4.68.62,6.81-1.21,2.95-4.9,4.15-6.25,7.23C120.94,263.58,122.37,268.38,125.07,272Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.56,274.27c4.78-.54,7.13-6.88,4.28-10.3-1.8-2.17-4.62-3.27-6.43-5.43-3-3.56,0-6.5,1.83-9.77,4-7.09-.76-12.23-5.86-17-3.86-3.59-4.49-7.53-4.52-12.56,0-.08.14-.08.14,0,.2,3.71.55,7.37,3,10.38,2,2.44,4.79,4.18,6.74,6.71,3.28,4.25,3.49,8.7.82,13.26-.76,1.31-2.17,2.77-2.52,4.22-.83,3.42,1.73,5.32,4.16,7.14,1.86,1.39,3.93,2.93,4.54,5.27.94,3.54-2.47,8.12-6.17,8.33C190.42,274.56,190.37,274.29,190.56,274.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.81,277.67c3-1.6,6.23-3,8.08-6,2.75-4.36-.26-7.88-3.07-11.19-1.21-1.42-2.21-2.82-2-4.74.23-2.87,2.47-5.19,3-8,1.15-6.77-5.5-11.19-8.72-16.33s-4.17-11.27-5.18-17.23a.1.1,0,0,1,.2,0c1.35,7.61,3.29,14.78,8.45,20.82,3.6,4.22,7.43,8.78,5.41,14.56-.5,1.42-1.42,2.7-1.88,4.12-.92,2.82-.22,4.7,1.61,6.83s3.81,4.15,4,6.95c.43,5.45-5.23,8.8-9.63,10.69A.24.24,0,0,1,187.81,277.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.59,257.6c2.48-3.21,6.3-4.7,5.48-9.44-.56-3.26-2.25-5.91-1.47-9.32.65-2.82,2.59-5,4.84-6.74,2.86-2.27,6-4.08,8.13-7.1,2.33-3.3,3.47-7.22,4.62-11,0-.08.16,0,.14,0-1.26,5.16-2.76,10.44-6.9,14.18-2.16,1.95-4.75,3.4-6.89,5.38-3.85,3.55-3.95,7.59-2.5,12.24.66,2.14,1.25,4.28.19,6.4s-3.19,3.38-4.71,5.14c-6.45,7.44,2.75,17.45,10.57,19.1.35.08.29.61-.07.55-5.86-1.07-11.91-6.5-13-12.23A8.86,8.86,0,0,1,121.59,257.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.72,261.69c.17-3.42,2.41-5.25,4.18-7.88,2.78-4.14.16-8.39,0-12.86a10.83,10.83,0,0,1,3.26-7.92c2.73-3,6.17-5.05,8.43-8.49a21.77,21.77,0,0,0,3.52-12.33c0-.08.12-.07.13,0a20.84,20.84,0,0,1-6.12,16.05c-2.73,2.69-6.36,4.84-8,8.52-1.69,3.9.24,7.57.67,11.51a8.56,8.56,0,0,1-1.9,6.57c-1.11,1.43-2.45,2.73-3.1,4.49a10.42,10.42,0,0,0,.51,7.36c3,7.29,10.54,12,17.87,13.42.26.05.22.46,0,.42a25.72,25.72,0,0,1-16.56-10.39A14.1,14.1,0,0,1,121.72,261.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.8,260.33c7.92,9,37.55,35.62,45.07,35.17,7.82-.47,36.28-10.1,42.18-14,3.28-2.19-10.25-29.54-13.85-27.33s-26.38,12.9-29.55,13.08-32.94-18.79-43.16-22.11C147.87,239.39,160.54,255.49,164.8,260.33Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.79,274c-4.28,4.45-16.59,10.13-20.09,10.35S229.86,264,231.42,260.76s17.12-17.11,23.36-17.92S268.22,269.42,263.79,274Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.43,246c.92,3.14,3.45,2.22,3.45,2.22s-5.67,2.85-5.14,6.43,5.52,2.08,5.88,2c-.3.15-5.44,2.91-4.53,6.45s5.72,1.45,6,1.31c-.24.23-3.31,3.37-2,5.91,2.23,4.35,10.3-3.47,14.26-3.24,0,0,.37,6.75.42,6.94,0,0,7.83-7.28,7.85-12.62A3.42,3.42,0,0,0,269,258s2.79-2.06,2.16-4.87c-.32-1.44-2.91-2.21-2.91-2.21a4.28,4.28,0,0,0,1.45-4.21c-.56-2-3.07-2.43-3.07-2.43s12.58-6.52,11.26-10c-2.29-6-28.44,9.43-31,8.26C245.59,242,245,244.66,245.43,246Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.26,244.17a.05.05,0,0,0,0-.1,30.47,30.47,0,0,0-17.61,4.19c-.17.11-.54.94-.35.84C253.13,246.46,260,244.76,266.26,244.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.35,250.89c.07,0,.06-.12,0-.12a28.5,28.5,0,0,0-18.93,5.76c-.18.15-.2.47,0,.32C253.24,254.22,262.7,251.4,268.35,250.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,264.85c5.33-4,11.41-5.84,17.92-6.86.08,0,.06-.13,0-.14-3.32-.37-7.4.71-10.51,1.83a17.41,17.41,0,0,0-7.53,5C250.63,264.76,250.73,264.94,250.85,264.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.78,248.19c-.2.13.48.37.29.51-2.11,1.44-5.75,4.22-5,6.2.63,1.59,3.2,1.83,4.23,1.54l2.58-.74-2.17,1.59a11.12,11.12,0,0,0-2.51,2.52,3.93,3.93,0,0,0-.81,3.1,2.24,2.24,0,0,0,2.13,1.85,6.69,6.69,0,0,0,3.3-.81l2.85-1.4-2.22,2.25a10.53,10.53,0,0,0-1.6,2.09,4.27,4.27,0,0,0-.65,2.36,2,2,0,0,0,1.24,1.73,4.35,4.35,0,0,0,2.49-.09,33.71,33.71,0,0,0,5.11-2.06c.85-.38,1.7-.77,2.57-1.11a6.57,6.57,0,0,1,2.72-.63,7.22,7.22,0,0,0-2.62.86c-.83.41-1.64.86-2.46,1.3a29.79,29.79,0,0,1-5.11,2.38,5.18,5.18,0,0,1-3,.2,2.85,2.85,0,0,1-1.92-2.48,5.15,5.15,0,0,1,.73-3,10.86,10.86,0,0,1,1.75-2.36l.62.84a7.82,7.82,0,0,1-3.89,1,3.31,3.31,0,0,1-2-.83,3.72,3.72,0,0,1-1.06-1.9,5,5,0,0,1,1-3.93,12,12,0,0,1,2.8-2.72l.42.85c-1.32.33-4.23.37-5.52-2C241.87,252.08,247.67,248.73,248.78,248.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.42,260.76s3.8-16.64,8.52-20,16.54,1.57,20.57,4.05c5.57,3.42,2.55,7.06-1,7.3-4.08.28-10.07-1.34-10.49-1.44,0,0,2.35,9.72-2.78,14.91S231.42,260.76,231.42,260.76Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,241.09c3.73,1.14,7.57,2.31,10.6,4.88,1.71,1.51,2,4.3-.13,5.62-1.74,1.16-4,1.11-5.91,1a27.59,27.59,0,0,1-7.7-1.55l.57-.54a17.3,17.3,0,0,1,.43,7.4,15,15,0,0,1-2.83,6.74,16.37,16.37,0,0,0,1.51-3.3,17.94,17.94,0,0,0-.2-11.4,26.79,26.79,0,0,0,8.27,1.65,14.78,14.78,0,0,0,3.72-.15c2.76-.54,3.72-2.87,1.71-5-2.78-2.55-6.58-3.93-10-5.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,256.2l13,33.75s-27.6,7.84-36.37,7.11-38.64-28.88-48.05-40.51-4.21-16.25,9.56-10.62,36.9,19.82,38.8,19.51S232.2,256.2,232.2,256.2Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,275.67c-.87-2.43-4.29-12.15-4.95-14.62a0,0,0,0,1,.06,0c1.1,2.24,4.76,11.73,5.64,14.15a140.68,140.68,0,0,1,4.82,14.68c0,.08-.11.15-.15.06C234.25,285.29,232.67,280.44,231,275.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.09,296.61a21.33,21.33,0,0,1-5.23.45c-8.78-.73-38.64-28.88-48-40.51-8.22-10.16-5.3-15,4.74-12.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.72,323.62l73.75-3.24-6.42-28.51s6.42-8.23,2-16.63c-3.14-6-11.7-19-17.44-24.74-14-14-22-5.57-25.14-1.36C134.53,265.23,119.72,323.62,119.72,323.62Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.84,290.14a63.69,63.69,0,0,1,9.57.4c1.58.2,3.13.48,4.69.79.78.15,1.56.28,2.34.4a10.24,10.24,0,0,0,2.47.16c.07,0,.08.1,0,.11a18,18,0,0,1-2.33.25,17.19,17.19,0,0,1-2.27-.15c-1.6-.19-3.19-.46-4.79-.67-3.22-.42-6.45-.84-9.69-1A.14.14,0,0,1,162.84,290.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.38,293.9a70.42,70.42,0,0,1,7.79-1.34c1.31-.14,2.62-.21,3.94-.24.63,0,1.26,0,1.89,0s1.39.1,2.08.09c.07,0,.08.11,0,.11-.65,0-1.3.16-2,.23l-2,.19c-1.31.12-2.61.27-3.92.38-2.63.23-5.24.49-7.85.81C155.26,294.13,155.24,293.93,155.38,293.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.77,253.52c-18.91,23.25-39.56,61.85-29.45,69.32,9.24,6.82,41.19-1.84,61.08-10.86,3.79-1.72-13.72-35.09-17.55-32.85a109.21,109.21,0,0,1-12.55,6.47c-1.1.37,4.61-7.42,10.46-25.71C158.7,241.29,151.58,240.23,140.77,253.52Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.09,274c.23,4-9.62,3.72-9.62,3.72a7.36,7.36,0,0,1,3.2,3.84c.89,2.89-3.25,5.56-3.25,5.56a9.09,9.09,0,0,1,2.73,4.59c.58,2.85-3.21,6.14-3.21,6.14a8,8,0,0,1-.14,5.55c-2.09,4.65-9.93,5.16-14.71,6.44a103.21,103.21,0,0,0-15.61,5.9l-10.9-35.24s20.33-13.59,26.21-13.62C183.75,266.8,203.73,267.88,204.09,274Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.38,277.56c-5.28-1.23-10.84-1.2-16.2-1.11a.09.09,0,1,0,0,.18c5.34-.15,10.84,1.12,16.17,1.19A.13.13,0,0,0,194.38,277.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.26,286.68a13.89,13.89,0,0,0-3.7,0c-1.3.08-2.61.19-3.91.32-2.61.26-5.21.58-7.8,1-.12,0-.12.2,0,.18,2.6-.25,5.21-.47,7.82-.61l3.91-.19a16.89,16.89,0,0,0,3.69-.32A.18.18,0,0,0,194.26,286.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.83,297.81a9.85,9.85,0,0,0-3.33.17l-3.56.41c-2.37.26-4.75.52-7.13.7a.09.09,0,0,0,0,.18c2.42-.17,4.84-.3,7.26-.49,1.19-.09,2.37-.19,3.56-.3a9.32,9.32,0,0,0,3.2-.55A.06.06,0,0,0,193.83,297.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.62,280.09l9.78,38s-47.43,15.11-53.07,3.2,20.24-58.6,35.86-72.36,10.58,6.88,10.18,8.53c-1.82,7.33-11.08,26.7-11.08,26.7Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.79,280.17c-5.42,2.24-19.52,10.23-22.54,13.36-.08.09,0,.24.12.16,3-2.37,20.44-12.08,23.18-13.3a2.94,2.94,0,0,0,.22.42c.1.13.17.05.16-.08a8.23,8.23,0,0,0-.26-.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.82,301.89c-.67-2.66-3.25-13.29-3.68-16,0,0,.06-.07.07,0,.92,2.48,3.78,12.9,4.45,15.56a150.84,150.84,0,0,1,3.53,16c0,.1-.13.16-.17.06C150.27,312.41,149.13,307.12,147.82,301.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.92,284.43c1.34-3.35,3-6.57,4.49-9.86s3-6.53,4.4-9.85c0,0,.09,0,.08,0-.82,2.26-1.64,4.51-2.52,6.74.28-.36.55-.74.81-1.11.47-.68.91-1.39,1.33-2.11a0,0,0,0,1,.07,0,11.39,11.39,0,0,1-1.22,2.25,15.34,15.34,0,0,1-1.21,1.48c-.36.9-.74,1.81-1.14,2.7-1.47,3.33-2.57,6.6-4.53,9.67C143.42,284.51,142.88,284.54,142.92,284.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.38,325.29c9.8,1.38,40.59-5.76,45.84-7.12-.1-.56-.09-.76-.23-1.55,0-.1.15-.16.17-.05.19.74.78,2.21.57,2.31-2.49,1.14-36.79,9-46.34,6.65C115.24,325.49,115.23,325.27,115.38,325.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.12,248.15s12,13,21.62,11.14c8-1.53,4.66-12.93,4.66-12.93a24,24,0,0,0-12.66-3.85A20,20,0,0,0,145.12,248.15Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.45,245.52c.21,1.3,5.77,10,11.61,10.07,1.9,0,2.53-10.36,2.53-10.36l.22-.75,3.1-10.59L159.81,225l-1.75-1.19s-.66,3-1.44,6.64c0,.17-.07.34-.11.52s-.1.41-.13.6c-.13.55-.25,1.11-.36,1.67s-.18.85-.25,1.3-.16.89-.25,1.34A70.61,70.61,0,0,0,154.45,245.52Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.62,230.43a22.14,22.14,0,0,0,12.19,14l3.1-10.59L159.81,225l-1.75-1.19S157.4,226.75,156.62,230.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.58,213.79c5.35,18.6-5.18,23.91-9.19,25.06-3.64,1.05-16.18,4.14-23.43-13.8s-.29-26.32,7.91-29.15S179.22,195.2,184.58,213.79Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,211.34c-.45.06-.88,0-1.34.07a2.15,2.15,0,0,1-1.37-.19.68.68,0,0,1-.21-.82,1.7,1.7,0,0,1,1.52-.81,2.47,2.47,0,0,1,1.75.45A.74.74,0,0,1,181,211.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,214.5a11.19,11.19,0,0,0,1.2-.6,2.14,2.14,0,0,0,1.1-.84.68.68,0,0,0-.22-.81,1.7,1.7,0,0,0-1.73,0,2.52,2.52,0,0,0-1.29,1.26A.73.73,0,0,0,168,214.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.37,218.85s-.09.09-.07.14c.41,1.26.66,2.76-.36,3.51,0,0,0,.09,0,.07C173.31,222,173,220,172.37,218.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.85,217.86c-2.08.43-1,4.56.87,4.16S172.6,217.49,170.85,217.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.1,218.28c-.31.32-.56.82-1,1s-1-.16-1.41-.5c-.05,0-.07,0-.06.07.18.79.69,1.53,1.57,1.43s1.18-.92,1.18-1.76C170.4,218.33,170.22,218.15,170.1,218.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.41,216.47c0-.05.11,0,.13.09.26,1.29.78,2.72,2.05,2.87,0,0,0,.07,0,.08C180.13,219.65,179.46,217.73,179.41,216.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.23,214.86c2-.65,3.18,3.44,1.3,4S178.54,215.4,180.23,214.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.16,214.89c.39.12.82.43,1.21.34s.67-.63.83-1.14c0-.05.06,0,.08,0,.24.78.21,1.67-.5,2s-1.34-.2-1.74-.93C181,215.09,181,214.83,181.16,214.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.82,229a2,2,0,0,0,1.24.54,3.46,3.46,0,0,0,1.32-.61s.09,0,.07.06a1.78,1.78,0,0,1-1.5,1,1.41,1.41,0,0,1-1.24-.94C174.67,229.05,174.77,229,174.82,229Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,223s.76,1.83,1,2.73c0,.09-.18.18-.48.28,0,0,0,0,0,0a4.42,4.42,0,0,1-4.56-.51.1.1,0,0,1,.1-.16,6.68,6.68,0,0,0,4.19.1c0-.27-1.4-3.1-1.26-3.15a8,8,0,0,1,2.16-.07c-1.47-3.87-3.55-7.47-5-11.35a.13.13,0,0,1,.22-.12,67.21,67.21,0,0,1,5.85,12C181.38,223.29,179.35,223.1,179,223Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.22,225.65a5.33,5.33,0,0,1-1.51,2.27,2.31,2.31,0,0,1-1.36.56c-1.09.08-1.43-.84-1.51-1.69a5.83,5.83,0,0,1,0-1.36A6.91,6.91,0,0,0,179.22,225.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.71,227.92a2.31,2.31,0,0,1-1.36.56c-1.09.08-1.43-.84-1.51-1.69A2.5,2.5,0,0,1,177.71,227.92Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.58,225.7c3.52-.24,2.85-8.28,2.85-8.28s14.14-5.37,13-17.54a25.07,25.07,0,0,0,13.26,8.62s-4.87-14.36-15.73-14.85c0,0-12.2-1.79-18,9.82C143,215.36,151.21,225.87,153.58,225.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.34,199a13.08,13.08,0,0,1,.42,5.57,13.7,13.7,0,0,1-1.81,5.36,10.55,10.55,0,0,1-.79,1.18l-.42.58c-.15.18-.31.36-.47.53-.33.34-.64.7-1,1s-.73.61-1.09.9l-.56.44-.59.38-1.19.75c-.84.42-1.69.79-2.54,1.15.76-.53,1.57-1,2.32-1.5l1.1-.83.54-.42.5-.46c.33-.32.65-.63,1-.94s.59-.68.89-1l.44-.51.38-.56a10.45,10.45,0,0,0,.74-1.13,16.69,16.69,0,0,0,2.22-7.74A15.93,15.93,0,0,0,169.34,199Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.12,218.79l-.68-.51c.71-1,2.56-2.67,4.44-1.4l-.44.73C176.75,216.47,175.18,218.7,175.12,218.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.17,229.43l-.87-.05c0-.41.28-4,1.94-5.08s12.66-4.74,13.14-4.9l.27.82c-3.19,1.07-11.75,4-12.94,4.81S148.23,228.45,148.17,229.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.86,224.83a6.77,6.77,0,0,1-3.63-.37c-2.3-1.21-4.48-6.71-4.57-6.94l-.21-.54.57-.09c.43-.07,10.68-1.68,13.4.2,1.47,1,1.29,4.12.59,5.16C174.14,223.54,171.36,224.56,168.86,224.83Zm-7.12-7.11c.76,1.77,2.43,5.14,3.92,5.92,2,1.05,7.56-.4,8.58-1.91.49-.72.6-3.23-.34-3.88C172,216.55,165,217.25,161.74,217.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.7,220.71a3.86,3.86,0,0,1-2.75-.56,5.16,5.16,0,0,1-1.65-4.52c.53-2.69,6.58-4.77,7.27-5l.53-.18.08.55c0,.23.79,5.59.19,7.44a3.51,3.51,0,0,1-2.47,2A5.42,5.42,0,0,1,182.7,220.71Zm2.64-9c-2,.73-5.8,2.45-6.13,4.12a4.27,4.27,0,0,0,1.3,3.6,3.75,3.75,0,0,0,3.11.17,2.68,2.68,0,0,0,1.87-1.42C185.89,216.93,185.56,213.48,185.34,211.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.77,231.77a3.75,3.75,0,0,0,.93,0,2.83,2.83,0,0,0,.9-.15,2.59,2.59,0,0,0,1-.57,3.52,3.52,0,0,0,.61-.69,3.76,3.76,0,0,0,.51-1.21l-2.05-4.87s-5.31-5.11-7.7-3.1S151.38,231.22,154.77,231.77Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.41,223.48s0,.08,0,.08c2.39.47,4,2.29,5.2,4.26a1.81,1.81,0,0,0-2.75,0c-.05,0,0,.13.08.1a2,2,0,0,1,2.31.26,9.82,9.82,0,0,1,1.39,1.56c.14.18.48,0,.36-.21l0,0C156.47,226.69,153.5,223.17,150.41,223.48Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M680.17,363.2s-39.35,17.67-90.51,16.7c-54.36-1-80.39-19.23-80.39-19.23-39.1-31.93-42.33-78.19-13.48-105.65,17.46-16.6,29.93-13,50.7-15.25h.06A61,61,0,0,0,567.69,234c21.55-10.86,34.09-37.18,52.46-59.18q3.44-4.14,7.19-8c15.06-15.48,44.45-15.44,59.4,7C724.73,230.85,722.05,314.65,680.17,363.2Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M680.17,363.2s-39.35,17.67-90.51,16.7c-54.36-1-80.39-19.23-80.39-19.23-39.1-31.93-42.33-78.19-13.48-105.65,17.46-16.6,29.93-13,50.7-15.25h.06A61,61,0,0,0,567.69,234c21.55-10.86,34.09-37.18,52.46-59.18q3.44-4.14,7.19-8c15.06-15.48,44.45-15.44,59.4,7C724.73,230.85,722.05,314.65,680.17,363.2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M572,315.72c51.85,13.79,100-14.54,105.6-81.47,4.07-49-30.4-72.83-57.41-59.45-18.38,22-30.9,48.33-52.46,59.19a61.2,61.2,0,0,1-21.14,5.77h-.06c-.75.09-1.48.16-2.22.23C520.25,254.41,531.69,305,572,315.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.49,389.35c3.11.07,83.87-24.94,86.34-27.84.27-.32-1-12.28-3.09-21.77-.1-.45,28.66-38.18,28.66-38.18l-52-20.21-24.87,51.59L401,346.35s-26.92,27.1-29.31,30.58S369.38,389.28,372.49,389.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.22,389.8c3.24.09,87.55-25.7,90.14-28.71,1-1.14-.52-6.35-4.62-21.35l-55.28,6.68s-28.51,26.81-31,30.42S367,389.72,370.22,389.8Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.39,386.06c14-4.67,71-22.18,85.26-25.73.12,0,.14.05,0,.09-13.8,4.93-70.95,22-85.22,25.87C370.16,386.37,370.1,386.16,370.39,386.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,372.15a11.87,11.87,0,0,1,9.51.87,11.53,11.53,0,0,1,5.47,6.58c0,.08-.13.13-.17,0A13.73,13.73,0,0,0,374,372.33.1.1,0,0,1,374,372.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.76,352c5.63-1.8,12.8-1.81,17.73,1.74.19.14,0,.41-.2.37a82,82,0,0,0-17.42-1.38A.37.37,0,0,1,394.76,352Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.91,355c5.64-1.81,12.8-1.82,17.73,1.74.19.13,0,.4-.2.37A81.91,81.91,0,0,0,391,355.77.37.37,0,0,1,390.91,355Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.07,358.08c5.63-1.81,12.8-1.82,17.73,1.73.19.14,0,.41-.2.38a81.35,81.35,0,0,0-17.42-1.38A.37.37,0,0,1,387.07,358.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.22,361.12c5.63-1.81,12.8-1.82,17.73,1.73.19.14,0,.41-.2.37a81.91,81.91,0,0,0-17.41-1.38A.37.37,0,0,1,383.22,361.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,346.93c4.25,3,9.66,4.06,14.54,5.62.51.16.88-.33.88-.77a.16.16,0,0,0,.13-.21,31.11,31.11,0,0,0-9.57-12.9c-2.52-1.92-6.83-3.14-9,.11C382,341.85,384.53,345.18,387,346.93Zm-1.7-4.6C384,336,391,339,392.8,340.52a32.42,32.42,0,0,1,3.23,3.19,91,91,0,0,1,5.75,7.4c-2.35-.91-4.75-1.61-7.13-2.43C391.81,347.7,386.05,345.81,385.32,342.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.55,341.81c-1.57-3.55-6-3.06-8.83-1.58a31.05,31.05,0,0,0-11.56,11.14.16.16,0,0,0,.09.24.72.72,0,0,0,.74.9c5.07-.73,10.58-.88,15.27-3.15C420,348,423,345.18,421.55,341.81Zm-12.1,8c-2.49.42-5,.71-7.44,1.23a92.16,92.16,0,0,1,6.89-6.36,33,33,0,0,1,3.71-2.61c2-1.18,9.42-3,7.08,3C418.4,348.42,412.41,349.33,409.45,349.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.86,335.35l57.37,8.44s31.27-56.85,43.9-71l0,0a18.48,18.48,0,0,1,2.31-2.26h0a12,12,0,0,1,4.14-1h0c17-2.07,74.05,3.45,113.49.89l-18.43-24.62-8.17-10.92c-44.44-5-99-23.18-123.59-10.83C449.24,237.39,404.86,335.35,404.86,335.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.05,325.6c9.75,1.25,7,.76,16.7,2.12,4.77.66,28.72,3.93,33.07,5.29a.1.1,0,0,1,0,.19c-4.55,0-28.43-3.75-33.18-4.5-9.71-1.54-6.91-1.2-16.6-2.83A.14.14,0,1,1,412.05,325.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.93,332.21c6.48-10.86,36-64.44,41.89-66.56,5.35-1.92,112.49.25,114.07.26.12,0,.13.18,0,.18-12.68-.16-110.6-.46-113.4.65-5.8,2.3-41.11,64.46-42,65.76C462.29,332.85,461.7,332.58,461.93,332.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.11,247.92s3.4,32.3-13,48.38c-19.61,19.24-149.07,14.44-169.14,8s-20.71-38.85,1.22-46.36c20.86-7.15,113.36-11.3,115.55-12.17s8.6-11.12,8.6-11.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.71,247c0-.16.27-.11.26,0a17.84,17.84,0,0,0,4.18,11.46c3.08,3.55,7.61,5.53,11.71,7.61.4.2.1.82-.31.69a36.3,36.3,0,0,1-7.25-3.12,17.28,17.28,0,0,1-5.45-4.53A15.58,15.58,0,0,1,628.71,247Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.64,243.72c.92-1.17,1.91-2.28,2.87-3.42,2.26-2.69,4.53-5.39,6.9-8,.22-.24.66.11.45.38-1.59,2.08-3.28,4.1-4.94,6.14-.85,1-1.7,2.08-2.56,3.11a19.92,19.92,0,0,0-2.4,3c-.62,1.16.2,2.15,1.4,2.28a4.18,4.18,0,0,0,2.88-1.07,37.87,37.87,0,0,0,4.89-5.23c1-1.08,1.91-2.15,2.87-3.2s2.12-2.2,3.15-3.32c.06-.07.19,0,.13.11-.89,1.23-1.72,2.51-2.61,3.74s-1.81,2.45-2.73,3.66-1.79,2.26-2.72,3.36a11.36,11.36,0,0,1-2.75,2.47c-1.72,1-4.7,1.23-5.61-1A3.12,3.12,0,0,1,591.64,243.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.74,304.39c6.91.12,13.81.52,20.72.67s13.7.17,20.56.11q20.64-.21,41.25-1.63c13.88-1,28.85-2.36,42.63-4.27,6.6-.92,13.28-1.68,19.8-3.09a31.19,31.19,0,0,0,15.61-8c8.93-8.66,12.39-21.39,13.81-33.56.19-1.63.35-3.26.48-4.9,0-.11.18-.11.17,0-.8,12.48-2.73,25.48-10.57,35.51a31.12,31.12,0,0,1-12.78,9.93c-6.17,2.48-13,3.06-19.54,3.95C595,301,580,302.46,566.1,303.55s-28.05,1.77-42.1,2-28.1,0-42.13-.66c-1.72-.08-3.43-.18-5.14-.33A.08.08,0,0,1,476.74,304.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.28,274.21A22.24,22.24,0,0,1,467.52,261c5-3.39,10.92-4.94,16.81-5.8,6.66-1,13.4-1.47,20.1-2.13q20.61-2,41.25-3.72c13.75-1.14,43.37-3.45,45-3.52.15,0,.18.24,0,.26-13.28,1.48-25.35,2.75-38.66,4s-26.72,2.5-40.08,3.83q-10,1-20,2c-6.17.64-12.51,1.27-18.29,3.65-5,2.05-9.42,5.34-11.94,10.16a23.78,23.78,0,0,0-2,15.37,27,27,0,0,0,6.43,13,23,23,0,0,0,12,7.25c1.21.26,2.68.45,3.8.67.09,0,.17.2.09.2-9.95.26-19.15-7-22.74-16.08A26.59,26.59,0,0,1,458.28,274.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.62,176.3c-11,23.77-27.26,42.09-33.34,45.89-7.69,4.8-50.93,5.11-53.1,4.89-5.35-.56-2.22-36.24,3.53-35.87,8.74.55,38.76,3.84,41,2.32s14.95-12,32.23-27.8C612.89,154.84,617.42,161.55,610.62,176.3Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.73,226.83c-4,.65-22.5,2-27.74,1.25s-20.15-4.08-20-8.15,4.63-3.45,4.63-3.45-6.08-2.4-5.52-6.48,7.44-2.89,7.44-2.89-6.06-2.92-5.22-7,7.57-1.67,7.57-1.67-5.67-2.41-3.57-5.44c2.52-3.64,12.46,2,18.31,2.39,1.33.1,27.05,0,27.05,0Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.34,198.3c7.32,4.11,11.24,4.64,19.5,4.22.16,0,.21.23,0,.25-8.05,1.15-13.06,1.19-19.76-4.13C491.79,198.38,492,198.1,492.34,198.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,206.77c8,3.61,12.22,4.22,20.9,4.42.13,0,.14.21,0,.21-8.53.53-13.53.46-21-4.2C489.53,207,489.63,206.61,490,206.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.09,216.47c8,2.94,12.6,3.81,21.05,2.92a.16.16,0,0,1,.05.31c-8.53,1.75-14.3.7-21.16-3C488.56,216.47,488.59,216.29,489.09,216.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.57,197.26s-8.05-6.78-12.24-9-22.84-4.64-23.59-.65c-1,5.16,9.5,8.69,14.86,9.75,0,0-2.27,11.94,4.71,16.1S539.57,197.26,539.57,197.26Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.93,189.14c2.51,5.35,9.63,6.28,14.76,7.7a.49.49,0,0,1,.3.74c-.62,5.06,0,12.39,4,16,.11.11,0,.29-.15.2-4.83-3.27-6-10.42-5-15.92-5.28-1.37-12.38-2.62-14-8.68C503.87,189.13,503.92,189.11,503.93,189.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.49,189.67l5.07,42.4s34.1-3.66,41.51-8.91,24.49-31.94,32-47.33S611.74,154,602,162.7s-33.84,29.68-35,30S534.49,189.67,534.49,189.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.69,215.12c-.59-4.73-1.21-9.45-1.62-14.2-.23-2.69-.48-5.39-.69-8.09,0-.1.17-.13.18,0,.78,4.72,1.55,9.46,2.11,14.21s1.15,9.45,1.65,14.19c.28,2.7.48,5.39.59,8.1,0,0-.08.06-.09,0C546.88,224.61,546.28,219.87,545.69,215.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.11,175.83c-7.55,15.39-24.64,42.07-32,47.33-2.74,1.94-9.11,3.66-16.06,5.06l42.8-69C614.71,157.1,619,163.74,613.11,175.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.84,253.51c-.21.21-78.27-16.85-79-17.76-1-1.28,12.91-60,27.61-77.49,3.68-4.39,15.4-4.09,20.64.33C655.1,180.48,660.58,252.75,659.84,253.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.57,164.78c14.82,11.38,53.88,57.42,45.72,68.35s-64.08,7.33-80.4,2.63c-4.85-1.39,7.59-32.28,12.77-33.81,4.31-1.28,28.53,5.28,29,3.88.49-1.59-4.87-11.8-13.53-30.45C620.1,153.87,630,159.75,636.57,164.78Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.9,198.36c-10.8.28-13.52,2-22.76-2.59-6.06-3-10.58-.44-6.46,5.27,6.73,9.34,20.73,11.9,25.84,11.39Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.6,203.86s-13-4.61-24.48-5.45c-8-.58-25.46.1-39,19.71-3.22,4.66-4.51,13.57,3.51,7.88,5.7-4,8.09-8.32,11.84-10.07,0,0-.3,11.54,4.49,14.58A104.34,104.34,0,0,0,591,237.58a23.56,23.56,0,0,0,1.54-2.33s4.74,2.42,12.56.34Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.43,199.07c-3.35,2.52-10.36,8-14.54,14.44-4.64,7.17-11.64,22.24-6.31,25.62,3.91,2.47,7.09-3,7.09-3s-1.58,6.84,2.44,8.3c3.66,1.33,5.86-3.09,5.86-3.09s-.24,4.32,3.53,4.92c4.54.72,4.31-8.44,9.55-11.68C598.22,233.81,589.43,199.07,589.43,199.07Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.29,217.15c-2.76,2.88-7.34,11-7.71,18.77,0,.18.12.28.17.12a83.94,83.94,0,0,1,7.61-18.85S583.32,217.12,583.29,217.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.4,222c-2.13,2.74-6.48,11.36-6.58,19.2,0,.18.14.27.17.11a89.91,89.91,0,0,1,6.48-19.27S590.43,222,590.4,222Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.41,215.86c-3.27,1.58-5.22,3.64-7.79,6.14a49.27,49.27,0,0,1-4,3.54c-1.28,1-3.15,2.47-4.84,1.54a2.87,2.87,0,0,1-1.1-2.71,14,14,0,0,1,1.24-4.22c0-.05-.06-.1-.09-.05a20.53,20.53,0,0,0-1.49,3.83,4.7,4.7,0,0,0,.14,2.73c.82,1.82,3.1,1.69,4.59.91a14.93,14.93,0,0,0,2.49-1.76c.75-.62,1.48-1.27,2.19-1.94,1.45-1.37,2.82-2.83,4.25-4.22a45.85,45.85,0,0,1,4.44-3.68A.07.07,0,0,0,573.41,215.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.22,229.15a108,108,0,0,1,5.28-13.22c0-.05,0-.1-.09-.05-2.25,3-5.44,10.44-6.08,12.77s-1.33,5.22-.94,7.6c.6,3.59,3.09,3.88,4,3.91a4.79,4.79,0,0,0,3-1,9.54,9.54,0,0,0,2.34-3.07c0-.05-.05-.11-.09-.05-1,1.62-2.84,3.36-4.84,3.43a3.35,3.35,0,0,1-2.42-.83,4.32,4.32,0,0,1-1.05-2.8A19.94,19.94,0,0,1,568.22,229.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.6,202.31l-11.22,39.11s69.92,4,73.79-8.75S654.24,178.39,640.22,167c-16.24-13.23-17.11-7.67-11.82,5.57,5.54,13.86,15.08,33.65,15.08,33.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.57,212.45a78.21,78.21,0,0,0-10.79-4.14,75.71,75.71,0,0,0-11.15-2.46c-2.15-.34-4.31-.57-6.47-.81-.06,0-.07.09,0,.1a98.15,98.15,0,0,1,11.25,2.36q5.52,1.44,11,3.07c2.06.62,4.09,1.34,6.13,2C665.62,212.63,665.66,212.49,665.57,212.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.76,202.17c.35,0,19.8,3.06,20.45,3.24-.12-.26-5.06-9.52-5.79-10.87l-.21-.41c-.44-.58-.89-1.16-1.31-1.76L633.3,190s0,0,0,0c.57.74,1.14,1.49,1.7,2.24.26.35.51.71.76,1.06-.5-1-1-1.92-1.46-2.89-.76-1.55-1.48-3.11-2.19-4.68a0,0,0,1,1,.08,0c1.45,2.7,3,5.35,4.45,8s7,12.58,7,12.58-21.5-3.79-21.91-3.89A.14.14,0,0,1,621.76,202.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.44,226c1.23-4.36,2.42-8.74,3.81-13.05.78-2.45,1.56-4.91,2.37-7.36,0-.09.19-.05.17,0-1.06,4.42-2.13,8.86-3.39,13.24s-2.46,8.72-3.77,13.06c-.75,2.46-1.56,4.9-2.46,7.32,0,.05-.1,0-.09,0C622,234.8,623.21,230.42,624.44,226Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.61,242.13c.49-1.22,1.07-3,1.61-4.18.14-.32.38-.3.27,0-.34,1.1-.58,2.31-.91,3.43,1,0,1.95,0,2.93.09l3.39.14c2.22.09,4.43.15,6.65.19q6.74.12,13.46,0a260.49,260.49,0,0,0,26.93-1.91c2.5-.32,5-.69,7.47-1.14a72.05,72.05,0,0,0,7.27-1.57c.07,0,.1.09,0,.12a40.78,40.78,0,0,1-6.24,1.88q-3.35.74-6.72,1.26c-4.49.69-9,1.14-13.55,1.47q-13.47,1-27,.83c-2.52,0-5-.08-7.57-.16-1.27,0-2.54-.09-3.81-.16S609.52,242.34,609.61,242.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614,175.26s15.44-11.7,24.31-10.27l6.71,7.66s2.38,1.13,3.35-.34c2.39-3.65,3.95-13-3.36-20.14-6.71-6.53-18.89-7.65-29.35-6.26-10,1.33-19.29,6.72-17.11,13.43S614,175.26,614,175.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.38,172.16s-10.14-9.37-10.69-14.24,9.46-8.18,15.79-9.17c9.79-1.54,16.14-.13,20.8,5.59S613.38,172.16,613.38,172.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.22,170.2c3.51.66,11.8-4.89,15.46-10,.25-.35.13-4.4.23-9.33.07-3,.22-6.32.57-9.35L611,143.86a48.72,48.72,0,0,1,.47,11.84,6.7,6.7,0,0,1-.28,1.23l0,.2C610.44,159.44,608.72,169.16,614.22,170.2Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.16,156.93a1.67,1.67,0,0,0-.06.2,13,13,0,0,0,1.95.33c10.82,1,15-11.82,16-15.81L611,143.86a48.75,48.75,0,0,1,.49,11.84A8.87,8.87,0,0,1,611.16,156.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634,120c1.46,6.93-3.84,26.12-9,30-7.52,5.69-19,5.28-23.59-3.56-4.47-8.57,2.87-33.45,8.59-36.93C618.38,104.38,631.83,109.71,634,120Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.28,129c-.54-.28-1-.63-1.49-1s-1.06-.62-1.33-1.28a.92.92,0,0,1,.41-1,2.24,2.24,0,0,1,2.27.31,3.29,3.29,0,0,1,1.53,1.85A1,1,0,0,1,617.28,129Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.08,126a15.07,15.07,0,0,0,1.78,0,2.9,2.9,0,0,0,1.81-.37.93.93,0,0,0,.21-1.1,2.29,2.29,0,0,0-2.1-1,3.32,3.32,0,0,0-2.27.76A1,1,0,0,0,604.08,126Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.69,144c-.39.23-.8.58-1.28.5a3.54,3.54,0,0,1-1.33-.66s-.08,0-.07,0a1.81,1.81,0,0,0,1.48,1.11,1.43,1.43,0,0,0,1.31-.91C612.84,144,612.74,143.93,612.69,144Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.26,139.73a4.56,4.56,0,0,1-3.44,1.26,5.61,5.61,0,0,1-1.61-.32,1.08,1.08,0,0,1-.3-.11l-.27-.11a.32.32,0,0,1-.19-.35h0a.29.29,0,0,1,0-.13h0l0-.12c.21-1,.68-2.51.68-2.51-.41.1-2.48.48-2.33,0,1.31-4.28,2.77-9,5-13a.12.12,0,0,1,.23.09c-1.1,4.16-2.92,8.1-4.09,12.26a8,8,0,0,1,2.25-.13c.13.07-1,2.89-1,3.35a.12.12,0,0,0,0,.05,6.33,6.33,0,0,0,4.94-.32C612.28,139.53,612.37,139.65,612.26,139.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.55,131.5c0-.05.09.08.08.14-.32,1.29-.46,2.83.63,3.51,0,0,0,.08,0,.07C612.84,134.71,613.05,132.68,613.55,131.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615,130.38c2.13.28,1.41,4.52-.56,4.26S613.22,130.15,615,130.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606,129.7s-.12,0-.12.1c-.17,1.32-.59,2.81-1.85,3,0,0,0,.07,0,.07C605.51,133,606.05,131,606,129.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.05,128.14c-2.09-.51-2.94,3.71-1,4.17S606.8,128.56,605.05,128.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605,116.64c1.1-1.56,2.31-3.1,3.41-3.22s.91,3.2,3.22,3.85c3.11.88,5.83-2.44,10.21-1.28,5.42,1.43,7.38,6.06,5.62,15.1-1.56,8.07,2.82,10.1,2.82,10.1s7.62-17.08,3.86-24-14.67-12-23.56-8C607.29,110.65,605,116.64,605,116.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.41,135.47s5.08-5.81,7.77-3.93-1.62,10.64-5.11,11.53a3.43,3.43,0,0,1-4.37-2.33Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.88,134a0,0,0,0,1,0,.09c-2.45.7-3.93,2.74-5,4.91a1.89,1.89,0,0,1,2.87-.21c.06.05,0,.14-.08.12a2.1,2.1,0,0,0-2.38.48,10.24,10.24,0,0,0-1.31,1.75c-.14.2-.5,0-.4-.19l0-.05C628.85,137.91,631.63,134,634.88,134Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.94,107.94a28.82,28.82,0,0,1,8.27-1.15c3.12.08,12.67,2.31,14.69,4.6s1.23,11.49,1.09,12.83-2,9.3-5.19,10.79-1.39-12.22-5.3-17.46S615.94,107.94,615.94,107.94Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.94,107.94s9.66,4.38,13.56,9.62,2.09,18.95,5.31,17.46c1.41-.66,2.23-1.84,3.09-3.9,0-4.08-.67-10.53-3.34-15.33-2.5-4.5-7.55-7.36-13.2-8.89A33.24,33.24,0,0,0,615.94,107.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.76,143c.3-3.69-1.91-14-4.94-20.19s-14-11.21-15.56-11.36c-3.91-.37-5,1.35-5.61.91s4-4.25,5.19-4.74a12.8,12.8,0,0,1,5.57-.52c1.68.3,11.91,2.93,15,7.94s6.54,18.25,5.07,21.28c-.35.73-1.44,1.07-1.93,2.1-.64,1.35-1.2,2.95-1.78,3.88C633.32,143.06,632.74,143.33,632.76,143Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.32,120.17a19.11,19.11,0,0,0,2.8-1.46,14.06,14.06,0,0,0,2.51-2,.06.06,0,1,1,.09.07,10.42,10.42,0,0,1-2.35,2.29,9.14,9.14,0,0,1-3,1.27A.1.1,0,0,1,627.32,120.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.36,139.37c.14-.24.35-.45.51-.68a4.75,4.75,0,0,0,.48-.85,8.47,8.47,0,0,1,.68-1.71,7.08,7.08,0,0,1,1-1.08,2.44,2.44,0,0,0,.95-1.37c0-.08.13-.06.12,0-.16,1.1-1,1.78-1.65,2.63a11.66,11.66,0,0,0-.79,1.81,2.94,2.94,0,0,1-1.2,1.38C633.42,139.55,633.31,139.46,633.36,139.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.7,135.24a15.45,15.45,0,0,0,1.22-1.08,12,12,0,0,0,1-1.24c.3-.43.56-.88.86-1.31s.75-1,1.07-1.51c0-.07.14,0,.1.07-.33.55-.57,1.15-.88,1.71a14.48,14.48,0,0,1-.93,1.38,7.91,7.91,0,0,1-1.06,1.18,4,4,0,0,1-1.33.86A0,0,0,0,1,632.7,135.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.93,131.48a10.54,10.54,0,0,0,2.32-1.94c.66-.74,1.27-1.52,1.87-2.3,0,0,.14,0,.11.06a12.24,12.24,0,0,1-1.68,2.57,5.9,5.9,0,0,1-1.11,1,7,7,0,0,1-1.45.71C631.93,131.61,631.86,131.52,631.93,131.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,127.85a3.48,3.48,0,0,0,1.11-.83q.57-.54,1.11-1.11l1-1.08a3.62,3.62,0,0,0,.85-1.24c0-.07.14,0,.12,0a3.84,3.84,0,0,1-.63,1.36,10.12,10.12,0,0,1-1.05,1.3,12.74,12.74,0,0,1-1.21,1.11,2.4,2.4,0,0,1-1.3.62A.08.08,0,0,1,631,127.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.63,123.36c.39-.28.77-.56,1.14-.87s.71-.63,1.06-1,.73-.69,1.06-1.06a.06.06,0,0,1,.1.08,10.4,10.4,0,0,1-.87,1.22,11.55,11.55,0,0,1-1.06,1,11.36,11.36,0,0,1-1.17.9,3.81,3.81,0,0,1-1.31.64.09.09,0,0,1-.08-.14A7.26,7.26,0,0,1,630.63,123.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.84,117.67c.43-.39.85-.78,1.31-1.13s1-.68,1.47-1a15.86,15.86,0,0,1,3.12-1.47c.06,0,.13.07.06.11-1.94,1.21-3.95,2.34-5.89,3.57A.06.06,0,0,1,624.84,117.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.12,114.22a6.89,6.89,0,0,1,1.41-1,17.06,17.06,0,0,1,3.39-1.26.07.07,0,0,1,.05.12c-1,.48-2.09,1-3.11,1.49a15.49,15.49,0,0,0-1.46.86c-.47.33-.86.74-1.31,1.08,0,0-.09,0-.07,0A4.24,4.24,0,0,1,623.12,114.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.3,112.32a8.49,8.49,0,0,1,1.32-1,9.56,9.56,0,0,1,2.9-1.15.06.06,0,0,1,0,.12,18.8,18.8,0,0,0-2.79,1.43c-.45.28-.88.59-1.31.88a14.49,14.49,0,0,1-1.28.94s-.07,0,0-.06A8,8,0,0,1,620.3,112.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.39,110.17c.43-.25.87-.48,1.32-.71a4.73,4.73,0,0,1,1.37-.52c.07,0,.09.09,0,.12-.83.48-1.66,1-2.49,1.47a12.87,12.87,0,0,0-2,1.75s-.08,0-.06,0A4.71,4.71,0,0,1,618.39,110.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.74,109.16a7.9,7.9,0,0,1,2.67-1.14c.06,0,.1.1,0,.12a9.33,9.33,0,0,0-2.47,1.32,12.42,12.42,0,0,0-2.07,1.9s-.1,0-.08,0A6.49,6.49,0,0,1,615.74,109.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.91,110.24a6.25,6.25,0,0,1,.4-.5,6.09,6.09,0,0,1,1-.87,13,13,0,0,1,2.31-1.27c.08,0,.12.08,0,.11a10.39,10.39,0,0,0-2.18,1.34,7.5,7.5,0,0,0-.93.85,4.6,4.6,0,0,0-.41.47,2.82,2.82,0,0,1-.38.46s-.11,0-.09,0A1.61,1.61,0,0,1,611.91,110.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.69,110.1a8.88,8.88,0,0,1,.79-.71,8.52,8.52,0,0,1,.87-.61c.31-.19.63-.37.93-.57a.06.06,0,1,1,.07.1,5.63,5.63,0,0,0-.89.65l-.8.65-.8.66a8.59,8.59,0,0,1-.8.69.05.05,0,0,1-.07-.07A5.21,5.21,0,0,1,609.69,110.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.38,172.16s13.38-17.26,27.38-17.36L638.29,165s-8.21-1-24.31,10.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642,165.65a17.61,17.61,0,0,0-7.51,0,33.31,33.31,0,0,0-7.17,2.3,59.09,59.09,0,0,0-6.7,3.48l-3.18,2.05-3.09,2.2L614,176l-.33-.22a62.87,62.87,0,0,1-6.85-5.41,37.42,37.42,0,0,1-3.09-3.08c-1-1.1-4.9-5.82-5.44-9,1.24,3.14,6.81,9.64,9,11.46,1.12.91,2.27,1.76,3.44,2.6s2.35,1.66,3.55,2.43l-.67,0,3.1-2.28c1.07-.72,2.15-1.41,3.23-2.1s2.24-1.28,3.39-1.87,2.32-1.13,3.53-1.57a30.71,30.71,0,0,1,7.48-2c.63-.1,1.28-.12,1.93-.17s1.29,0,1.93,0A11.22,11.22,0,0,1,642,165.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645,172.65a37.17,37.17,0,0,1-3.59-3.62,38.43,38.43,0,0,1-3.12-4,42.16,42.16,0,0,1,6.71,7.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.4,169.54a76.64,76.64,0,0,1-.44,13.19c-.35,3.06-3,13.82-6.32,13s3.13-7.16,4.87-12.79.77-10.06,1-13.53Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M619.4,169.54a76.64,76.64,0,0,1-.44,13.19c-.35,3.06-3,13.82-6.32,13s3.13-7.16,4.87-12.79.77-10.06,1-13.53Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M607.31,168.53a109.13,109.13,0,0,0-4.23,12.33c-.74,2.69-2.15,12.64.94,13s-.22-7.08.22-12.41,2.89-9.81,3.85-12.82Z",
    style: {
      fill: "#7D6DE5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M607.31,168.53a109.13,109.13,0,0,0-4.23,12.33c-.74,2.69-2.15,12.64.94,13s-.22-7.08.22-12.41,2.89-9.81,3.85-12.82Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 569.91,
    y: 209.99,
    width: 3.1,
    height: 76.89,
    transform: "matrix(0.02, -1, 1, 0.02, 312.25, 815.09)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.08,
    y: 227.49,
    width: 3.1,
    height: 42.55,
    transform: "matrix(0.02, -1, 1, 0.02, 328.77, 832.57)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "568.62 249.93 501.24 248.66 492.59 202.71 559.97 203.99 568.62 249.93",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.56 249.87 498.19 248.6 489.53 202.66 556.91 203.93 565.56 249.87",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532,227.37a4,4,0,0,1-4.1,4.42A5.11,5.11,0,0,1,523,227.2a4,4,0,0,1,4.1-4.41A5.1,5.1,0,0,1,532,227.37Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.44,320.78c3.63,10.42,18.95,51.05,22.57,54,4.31,3.54,29.6,2.17,30.52-2.35,2.39-11.69-30.73-52.11-45.26-63.39C361.17,303.56,354.36,303.32,360.44,320.78Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.51,370.4c-3.27,2.44,5.12,32.75,10.87,31,21.15-6.3,39.73-19.44,42.65-24.19A11,11,0,0,0,404.82,361C394,358.42,361.74,368,358.51,370.4Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.44,368.64s-27.12-3.47-37.72.05c-5.31,1.76-26.26,12.8-23.7,17.94,2.31,4.65,8.77-.18,8.77-.18s-7.56,4.62-3.84,8.53,11.54-3.17,11.54-3.17-8.36,4.35-4,8.14c3.78,3.3,13.65-3.92,13.65-3.92s-9.27,3.6-5.73,7.36c3.92,4.15,20.08-4.82,20.08-4.82,11,7,17.23,4.32,25.53,1.55C375.4,399.66,369.44,368.64,369.44,368.64Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.13,393.4c.64-.54,1.29-1,1.93-1.59a41.85,41.85,0,0,1,3.84-2.93c1.32-.86,2.68-1.66,4.06-2.42s3-1.45,4.44-2.29a.09.09,0,1,1,.09.16,44.28,44.28,0,0,0-4.14,2.68c-1.33.9-2.66,1.82-4,2.74s-2.63,1.7-3.95,2.57c-.66.42-1.29.88-1.93,1.34a12.91,12.91,0,0,1-1.85,1.27c-.06,0-.12-.06-.08-.11A10.08,10.08,0,0,1,322.13,393.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.23,387.44a64.87,64.87,0,0,1,7-5.61,44.87,44.87,0,0,1,7.93-4.27.09.09,0,0,1,.08.16c-2.49,1.69-5,3.34-7.52,5-1.23.8-6.7,4.65-7.32,5C315.27,387.78,315.14,387.56,315.23,387.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.47,399.16a64.57,64.57,0,0,1,6.7-5.16,58.25,58.25,0,0,1,7.87-3.57c.1,0,.18.11.09.16-2.52,1.39-5.06,2.72-7.52,4.23-1.19.73-5.8,3.93-7,4.53C328.5,399.4,328.4,399.25,328.47,399.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.2,309.74C315,345.57,290.61,399.63,286,410.59c-3.15,7.44,36.66,23.2,38,17.83,1.77-6.88,22.66-77.1,30.07-109.09C358.18,301.69,346.19,302.89,341.2,309.74Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.05,442.34c6.48-2.94,7-13.92,7-13.92l-35.88-22.25c-2.88,7.48-11.12,14.93-19.95,17.15-10,2.53-20.19,6.45-20.88,7.49-1.31,2,1.2,5.12,8.35,5s21-2.72,21.91-2.65a5,5,0,0,1,.84.23h0c.32.22,8.19,8.94,12,11.53,2.29,1.58,11.38,1.31,16.67.9C315.57,445.17,316,443.12,317.05,442.34Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.36,427.74s-17.05-3.47-20.38-2-24.58,7.05-25.94,9,1.2,5.12,8.35,5,21-2.72,21.91-2.66,15.2,5.52,16.67,5.62S290.36,427.74,290.36,427.74Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,424.42c-1.91.05-3.81.17-5.71.28-.95.07-1.9.15-2.86.25l-1.43.18c-.23,0-.48.07-.72.11s-.52.14-.73.21q-5.44,1.65-10.9,3.38c-3.63,1.17-7.24,2.31-10.86,3.58a11.93,11.93,0,0,0-2.61,1.34,5.42,5.42,0,0,0-1.12,1,2.49,2.49,0,0,0-.6,1.45,2,2,0,0,0,.61,1.43,4.16,4.16,0,0,0,1.22.84,10,10,0,0,0,2.74.84,12.45,12.45,0,0,1-2.61-1.07,4.08,4.08,0,0,1-1.06-.86,1.53,1.53,0,0,1-.4-1.16,3,3,0,0,1,1.57-2,12.46,12.46,0,0,1,2.52-1.14c3.62-1.08,7.28-2.2,10.91-3.35s7.24-2.32,10.84-3.62a13.66,13.66,0,0,1,2.72-.59c.93-.15,1.88-.27,2.82-.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.65,430.93s-18.71-3.72-22-2.28-24.58,7.05-25.94,9,1.2,5.12,8.35,5,21-2.72,21.91-2.66,15.2,5.51,16.67,5.62S292.65,430.93,292.65,430.93Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.88,426.57c-2.33.15-4.66.4-7,.65-1.16.14-2.33.3-3.49.47q-.87.13-1.74.3a12.23,12.23,0,0,0-1.73.47q-6.68,2.12-13.33,4.3L250,435l-1.66.58a13.53,13.53,0,0,0-1.67.67,7.38,7.38,0,0,0-1.56,1A3.11,3.11,0,0,0,244,438.9a1.86,1.86,0,0,0,.09,1.07,2.47,2.47,0,0,0,.6.83,5.62,5.62,0,0,0,1.59,1,16.83,16.83,0,0,0,3.44.92,20.48,20.48,0,0,0,7-.12,21.74,21.74,0,0,1-6.93-.36,16.45,16.45,0,0,1-3.28-1,5,5,0,0,1-1.36-.89,1.27,1.27,0,0,1-.43-1.24,2.41,2.41,0,0,1,.87-1.18A6.79,6.79,0,0,1,247,437c1-.45,2.16-.76,3.25-1.13l6.66-2.18c4.44-1.47,8.87-2.93,13.28-4.5a11.33,11.33,0,0,1,1.63-.51l1.7-.37c1.14-.22,2.29-.42,3.44-.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.63,430.32s-17,.57-20.09,1.91-17.85,4.26-19.11,6.1,1.12,4.76,7.76,4.67,14.55-.24,15.37-.18l15.1,1.2C293,444.12,292.63,430.32,292.63,430.32Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.05,429.07c-3,.29-6,.63-9,1-1.5.16-3,.33-4.49.52l-1.12.15a8.82,8.82,0,0,0-1.14.22c-.74.19-1.46.4-2.19.61-2.88.88-5.75,1.81-8.58,2.85-1.42.52-2.83,1.05-4.23,1.61-.7.28-1.4.57-2.1.88a13.77,13.77,0,0,0-2.08,1.08,1.89,1.89,0,0,0-.82,1.21,1.91,1.91,0,0,0,.38,1.4,5.55,5.55,0,0,0,1.88,1.59,9.9,9.9,0,0,0,4.54,1.24c3,0,6,0,9,0s6.05-.05,9-.12c1.48,0,3,.12,4.5.2s3,.12,4.51.13c-3-.49-5.95-.88-9-1.19l-9,.05c-3,0-6,0-9-.07a9,9,0,0,1-4.09-1.09A4.77,4.77,0,0,1,253.5,440a.82.82,0,0,1,.2-1.31,15.51,15.51,0,0,1,1.91-1l2.06-.88c1.39-.57,2.79-1.11,4.19-1.63,2.82-1,5.63-2.09,8.49-3,.71-.23,1.42-.45,2.14-.65a16.81,16.81,0,0,1,2.18-.41l4.46-.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,379.51l70.61,1.19s-13.92-51.45-35-72.13c-9.71-9.51-20.86-4.58-25,4.32C327.38,341,330,379.51,330,379.51Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.7,377.65l-69.85-1.22c0-.92-.06-2-.07-3.31l68.91,1.2C399.1,375.6,399.43,376.72,399.7,377.65Zm-3.77-11.83-66.05-1.15c0,1.16-.06,2.26-.08,3.31l67.25,1.17C396.69,368.09,396.32,367,395.93,365.82Zm-3.05-8.51-62.52-1.09c-.09,1.13-.16,2.23-.23,3.31l64,1.12C393.72,359.56,393.31,358.45,392.88,357.31Zm-3.36-8.51-58.3-1c-.14,1.12-.27,2.23-.39,3.31l60.05,1.05C390.44,351,390,349.92,389.52,348.8Zm-3.7-8.51-53.31-.93c-.21,1.11-.39,2.21-.57,3.31l55.38,1C386.84,342.52,386.33,341.41,385.82,340.29Zm-4.17-8.52-47.35-.83c-.28,1.1-.53,2.2-.77,3.3l49.82.87C382.79,334,382.23,332.88,381.65,331.77Zm-4.83-8.54-40.11-.7c-.36,1.1-.71,2.2-1,3.3l43.13.75C378.16,325.44,377.49,324.33,376.82,323.23Zm-5.89-8.55-31-.54c-.49,1.08-.95,2.17-1.39,3.28l34.83.61C372.6,316.87,371.77,315.75,370.93,314.68Zm-5.39-6.11a21.67,21.67,0,0,0-3.05-2.49l-15.95-.28a16,16,0,0,0-3.59,3.25l23.47.41C366.13,309.16,365.84,308.86,365.54,308.57Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.86,309.83c.87,1.74,7.45,6.56,13,4.73,2.86-.94,0-11.08,0-11.08l-.07-.78-1-11-16.63-4.26S346.61,309.33,346.86,309.83Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.09,287.44s1,5,2.13,10.22c5.46,5.14,12.13,5.56,15.61,5.7l-1.11-11.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.46,270.38c9,18.68-1,26.36-5.17,28.14-3.74,1.59-16.35,7.3-27.25-10.35s-5.08-27.75,3.08-32.23S358.44,251.69,367.46,270.38Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.21,293.09c3.64,2.35,10.48,6,15.89,3.9,10.46-4.14,9.48-20,9.48-20s5.74-1.68-.28-13.17c0,0-.45-12.45-16.64-11.67s-18.08,14.32-18.08,14.32S321.4,282.87,337.21,293.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.93,253.52s-10.59-5.78-21.59,4.07c-13.09,11.7-9,51.87-9.83,55.46s-2.37,4.44-2.9,7.66,2.13,5.31,2.45,6.45-2.89,7-2.89,7,17.66,4.66,28.75,2.5a230.84,230.84,0,0,0,23.92-6.43s-2.52-3.56-2.51-5.25,2-3.93,1.81-7-4.79-6.79-5.25-8.43,1.57-35.39-1.08-46S350.93,253.52,350.93,253.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.4,329.39a16.11,16.11,0,0,1-2.46-3.77,2.25,2.25,0,0,1-.2-1.16c.55-2.45,2.7-4.62,2.28-7.25-.54-2-2.5-3.68-3.83-5.24a6.69,6.69,0,0,1-1.82-3.07c0-.44,0-.79,0-1.18.43-12.63,1-28.75-1.07-41.29a22.57,22.57,0,0,0-2.9-8.37,22,22,0,0,1,3.37,8.28c2.56,12.52,2.08,28.75,1.48,41.41,0,.36,0,.76,0,1.06a6.3,6.3,0,0,0,1.58,2.63c1.38,1.72,3.33,3.41,3.84,5.65.38,2.81-1.84,4.93-2.6,7.42a2.08,2.08,0,0,0,.14,1,17.82,17.82,0,0,0,2.22,3.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.3,332.6c.72-1.55,1.75-3.51,2.35-5.08v0a3.42,3.42,0,0,0-.45-.67c-1.4-1.73-2.58-3.87-2.34-6.19.17-2.71,2-5,2.93-7.39a12.41,12.41,0,0,0,.49-5.07c-.39-14.81-.61-39.9,10.77-50.71a15.13,15.13,0,0,1,4.43-2.89,16.41,16.41,0,0,0-4.26,3.07c-10.7,11.15-10.25,35.73-10.1,50.51a12.47,12.47,0,0,1-.62,5.36c-1,2.52-2.82,4.48-3.09,7.18a7.52,7.52,0,0,0,1.31,4.85c.34.57.76,1.08,1.11,1.66a.6.6,0,0,1,.1.31,49.36,49.36,0,0,1-2.64,5.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.62,277.38s-6-5.25-8.51-2.95,3.14,10.69,6.84,11.1a3.55,3.55,0,0,0,4.16-3Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.78,276.79s0,.09,0,.1c2.61.37,4.41,2.26,5.85,4.33a2,2,0,0,0-3,.18c-.05.06,0,.15.09.11a2.2,2.2,0,0,1,2.52.16,10.93,10.93,0,0,1,1.58,1.61c.17.19.52,0,.38-.25l0,0C366.52,279.94,363.11,276.29,359.78,276.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.91,393l9.46,63.3s39.62,2.47,82.28-16.19c39-17.07,20.82-47.77-10.08-50.62C423.94,387,375.82,392.32,369.91,393Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.82,452.34c10.49,4.18,30.65,3.07,33.22,3.06,2.58.17,22.62,2.57,33.34-.92,19.52-6.33,18-23.34,17.46-34.28-.88-18-16.25-39.5-16.25-39.5L330,379.51s-11.66,23.23-13.69,41.1C315.05,431.5,313.76,444.76,332.82,452.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.19,427.19c-.28-3.71-1.16-15.41-1.3-17.56-.07-1.07-.33-7.29.09-7.33a55.32,55.32,0,0,1,6.69.08q3.29,0,6.55,0c4.42-.11,8.84-.41,13.25-.86a.47.47,0,1,1,.09.93c-4.45.52-8.91.86-13.38,1-2.18.09-10.62.27-12.57,0,0,.88.46,4.14.53,4.88a26.06,26.06,0,0,1,2.79.26c1,.1,2.06.18,3.1.23,2.14.12,4.3.16,6.45.13a99.75,99.75,0,0,0,12.45-1,.09.09,0,1,1,0,.18,72.48,72.48,0,0,1-12.72,1.37c-2,0-4,0-6-.14-1.09-.07-2.17-.16-3.25-.27a19.92,19.92,0,0,1-2.79-.38c0,.15,0,.29,0,.44.19,2,1.18,14.07,1.53,18,2.18,1.09,12.86,6.38,14.15,5.73,2.46-1.24,10.91-6.53,13.37-7.82-.23-3.56-.59-7.12-1.08-10.65q-.39-2.73-.87-5.44a35.28,35.28,0,0,1-.86-5.56c0-.16.24-.28.35-.13l.15.23a.11.11,0,0,1,0,.12,25.11,25.11,0,0,1,1.42,4.94c.4,1.84.77,3.7,1.09,5.56q.94,5.58,1.39,11.22a.7.7,0,0,1-.32.65c-3.71,2-13.89,8.16-14.81,8.3-1.77.27-14.8-5.85-15.14-6.1S372.23,427.65,372.19,427.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.79,426.38c.41-3.69,1.7-15.35,1.91-17.49.11-1.08.6-7.27.22-7.32a44,44,0,0,0-6.08,0q-3,0-5.94-.14c-4-.18-8-.55-12-1.07a.47.47,0,0,0-.12.93q6,.87,12.1,1.25c2,.12,9.63.44,11.41.19-.05.89-.59,4.13-.68,4.86a21.79,21.79,0,0,0-2.54.23c-.94.08-1.88.14-2.83.18-1.95.09-3.91.09-5.86,0a80.31,80.31,0,0,1-11.27-1.15c-.12,0-.14.16,0,.18a59.39,59.39,0,0,0,11.49,1.57c1.82.06,3.64,0,5.46-.05,1-.05,2-.13,3-.22a15.61,15.61,0,0,0,2.55-.33l-.06.43c-.26,2-1.66,14-2.14,18-2,1-11.94,6.17-13.09,5.5-2.17-1.27-9.63-6.69-11.81-8q.54-5.34,1.43-10.61c.31-1.81.65-3.62,1-5.41a39.06,39.06,0,0,0,1-5.54c0-.16-.2-.29-.31-.13l-.15.22a.1.1,0,0,0,0,.12,27.25,27.25,0,0,0-1.49,4.91c-.45,1.83-.86,3.68-1.22,5.53-.74,3.7-1.31,7.43-1.74,11.18a.72.72,0,0,0,.27.65c3.28,2.07,12.27,8.35,13.1,8.5,1.6.3,13.69-5.6,14-5.84S347.74,426.84,347.79,426.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.82,386.86c-2.84,16.55-7.9,45.33-1.6,60.79-7.27-15.23-2.22-44.51,1.6-60.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.24,389.8c6.46,7.9,11.72,17.22,13.1,27.46-2.72-9.88-7.78-18.78-13.1-27.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.87 376.34 329.39 376.34 327.39 383.63 402.87 383.63 399.87 376.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.18,390.84a34.62,34.62,0,0,1,7,4.89c.93.91,1.71,1.88,2.71,2.76s2.06,1.8,3,2.74c1.89,1.85,3.47,3.82,5.3,5.69a22.51,22.51,0,0,1,4.51,6.21c0,.08.23,0,.19-.05-1-2.21-1.81-4.48-2.77-6.74a18.3,18.3,0,0,0-2.92-4.46c.8.87,1.6,1.73,2.48,2.57a27.1,27.1,0,0,1,3.85,4.4c0,.08.25,0,.2,0-.74-1.56-1.39-3.17-2.07-4.75-.1-.23-.22-.46-.33-.69.39.54.78,1.07,1.2,1.59.61.76,1.24,1.52,1.79,2.3.25.36.5.71.72,1.08l.09.16v0a1.14,1.14,0,0,0,.64.92c.06,0,.14,0,.12-.05a49.85,49.85,0,0,0-1.43-4.83,28.57,28.57,0,0,0-11.3-13c-.35-.19-1.14.12-1,.37.87,1.26,1.86,2.47,2.87,3.68l-.24-.2a36,36,0,0,0-5.6-3.32c-.11-.06-.33.05-.28.12,1,1.38,2,2.83,3.08,4.18.36.44.77.86,1.18,1.28l-.56-.49A21.56,21.56,0,0,0,454,394.9c-2.79-1.49-5.37-3.08-8.35-4.34C445.4,390.47,445,390.72,445.18,390.84Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,416.7a43.06,43.06,0,0,0-2.26-8.42,11.07,11.07,0,0,0-2.66-3.6c-1.26-1.17-2.84-2.13-4.17-3.26-.08-.07-.27,0-.2.11a16.25,16.25,0,0,1,2.44,3.93,31,31,0,0,0,2.36,3.78,24.59,24.59,0,0,1,4.28,7.54C462.77,416.89,463,416.8,463,416.7Z",
    style: {
      fill: "#eb9481"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageIcon);
export default __webpack_public_path__ + "static/media/landingPageIcon.2fd4736bb6058d6d18442282bb2795e3.svg";
export { ForwardRef as ReactComponent };